<template>
  <el-container class="staff_info">
    <el-header class="header-style">
      <el-divider content-position="left">员工工资表</el-divider>
      <el-row>
        <el-col :span="4">
          <el-col :span="23">
            <el-select
              v-model="searchArr.cid"
              filterable
              remote
              reserve-keyword
              placeholder="请输入公司字号筛选公司"
              size="mini"
              clearable
              @change="handleCompanyChange"
              :remote-method="remoteCompanyMethod"
              :loading="loading"
            >
              <el-option
                v-for="company in companies"
                :key="company.id"
                :label="company.company_name"
                :value="company.id"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-col>
        <el-col :span="4">
          <el-col :span="23">
            <el-date-picker
              v-model="searchArr.dateTime"
              type="month"
              size="mini"
              format="yyyy 年 MM 月"
              value-format="yyyy-MM"
              :picker-options="pickerOptions"
              @change="handleDateTimeChange"
              placeholder="选择月份"
            >
            </el-date-picker>
          </el-col>
        </el-col>
        <el-col :span="4">
          <el-col :span="23">
            <el-select
              collapse-tags
              v-model="searchArr.status"
              placeholder="请选择通知状态"
              @change="handleCompanyChange"
              size="mini"
              clearable
            >
              <el-option :value="9" label="未通知"></el-option>
              <el-option :value="2" label="已通知"></el-option>
              <el-option :value="3" label="反馈中"></el-option>
              <el-option :value="4" label="已确认"></el-option>
              <el-option :value="10" label="无员工"></el-option>
              <el-option :value="11" label="有员工"></el-option>
              <el-option :value="5" label="社保完成"></el-option>
              <el-option :value="6" label="公积金完成"></el-option>
            </el-select>
          </el-col>
        </el-col>
        <el-col :span="2">
          <el-col :span="22">
            <el-popover placement="bottom-start" v-model="searchVisible" width="320">
              <el-row style="margin-bottom: 0.4rem; padding-top: 0.5rem">
                <el-col :span="6" style="margin-top: 0.1rem">理票会计：</el-col>
                <el-col :span="18">
                  <el-cascader
                    style="width: 100%"
                    v-model="searchArr.acc_id"
                    placeholder="请选择理票会计"
                    :options="allusersOptions"
                    size="mini"
                    :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                    clearable
                    filterable
                    :filter-method="filterOptions"
                  >
                  </el-cascader>
                  
                </el-col>
              </el-row>
              <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
                <el-col :span="6" style="margin-top: 0.1rem">记账报税会计：</el-col>
                <el-col :span="18">
                  <el-cascader
                    style="width: 100%"
                    v-model="searchArr.advisory_id"
                    placeholder="请选择记账报税会计"
                    :options="allusersOptions"
                    size="mini"
                    :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                    clearable
                    filterable
                    :filter-method="filterOptions"
                  >
                  </el-cascader>
                  
                </el-col>
              </el-row>
              <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
                <el-col :span="6" style="margin-top: 0.1rem">客服会计：</el-col>
                <el-col :span="18">
                  <el-cascader
                    style="width: 100%"
                    v-model="searchArr.ass_id"
                    placeholder="请选择客服会计"
                    :options="allusersOptions"
                    size="mini"
                    :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                    clearable
                    filterable
                    :filter-method="filterOptions"
                  >
                  </el-cascader>
                  
                </el-col>
              </el-row>
              <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
                <el-col :span="6" style="margin-top: 0.1rem">开票会计：</el-col>
                <el-col :span="18">
                  <el-cascader
                    style="width: 100%"
                    v-model="searchArr.invoice_id"
                    placeholder="请选择开票会计"
                    :options="allusersOptions"
                    size="mini"
                    :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                    clearable
                    filterable
                    :filter-method="filterOptions"
                  >
                  </el-cascader>
                  
                </el-col>
              </el-row>
              <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
                <el-col :span="6" style="margin-top: 0.1rem">财税负责人：</el-col>
                <el-col :span="18">
                  <el-cascader
                    style="width: 100%"
                    v-model="searchArr.leader_id"
                    placeholder="请选择财税负责人"
                    :options="allusersOptions"
                    size="mini"
                    :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                    clearable
                    filterable
                    :filter-method="filterOptions"
                  >
                  </el-cascader>
                  
                  </el-select>
                </el-col>
              </el-row>
              <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
                <el-col :span="6" style="margin-top: 0.1rem">所属业务：</el-col>
                <el-col :span="18">
                  <el-cascader
                    style="width: 100%"
                    v-model="searchArr.saler_id"
                    placeholder="请选择所属业务"
                    :options="allusersOptions"
                    size="mini"
                    :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                    clearable
                    filterable
                    :filter-method="filterOptions"
                  >
                  </el-cascader>
                  
                </el-col>
              </el-row>
              <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
                <el-col :span="6" style="margin-top: 0.1rem">是否绑定：</el-col>
                <el-col :span="18">
                  <el-radio-group v-model="searchArr.is_bind" size="mini">
                    <el-radio label="1" border>未绑定</el-radio>
                    <el-radio label="2" border>已绑定</el-radio>
                  </el-radio-group>
                </el-col>
              </el-row>
              <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
                <el-col :span="6" style="margin-top: 0.1rem">是否关注：</el-col>
                <el-col :span="18">
                  <el-radio-group v-model="searchArr.is_subscribe" size="mini">
                    <el-radio label="1" border>未关注</el-radio>
                    <el-radio label="2" border>已关注</el-radio>
                  </el-radio-group>
                </el-col>
              </el-row>
              <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
                <el-col :span="6" style="margin-top: 0.1rem">有无档案：</el-col>
                <el-col :span="18">
                  <el-radio-group v-model="searchArr.archives" size="mini">
                    <el-radio label="1" border>有档案</el-radio>
                    <el-radio label="2" border>无档案</el-radio>
                  </el-radio-group>
                </el-col>
              </el-row>
              <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
                <el-col :span="12" :offset="12">
                  <el-button size="mini" @click="handleClearSearchGetData"
                    >清除</el-button
                  >
                  <el-button type="primary" @click="handleSearchGetData" size="mini"
                    >查询</el-button
                  >
                </el-col>
              </el-row>
              <el-button slot="reference" size="mini">筛选</el-button>
            </el-popover>
          </el-col>
        </el-col>
        <el-col :span="2" v-if="this.searchArr.status === 11">
          <el-tooltip content="批量提醒客户确认员工信息" placement="top">
            <el-button type="primary" size="mini" @click="handleBatchStaffInfo(2)"
              >确认通知</el-button
            >
          </el-tooltip>
        </el-col>
        <el-col :span="2" v-if="this.searchArr.status === 10">
          <el-tooltip content="批量通知客户添加员工信息" placement="top">
            <el-button size="mini" @click="handleBatchStaffInfo(1)">添加通知</el-button>
          </el-tooltip>
        </el-col>
        <!-- <el-col :span="4" :offset="1">
        <el-tooltip content="是否开启公众号通知" placement="top">
          <el-radio-group v-model="is_send" size="mini" @change="handleChangeIsSendWxMsg">
            <el-radio-button label="1">开启</el-radio-button>
            <el-radio-button label="2">关闭</el-radio-button>
          </el-radio-group>
        </el-tooltip>
      </el-col> -->
      </el-row>
      <el-row style="margin: 0.2rem 0">
        <el-col> 日期：{{ list_month }} </el-col>
      </el-row>
    </el-header>

    <el-main class="main-style">
      <el-table height="calc(100vh - 266px)" :data="pageData" :show-overflow-tooltip="true" style="width: 100%;margin-top: .2rem;" border>
        <el-table-column label="公司名称" width="250" fixed>
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.company_name" placement="top">
              <div class="company_hover">
                <span class="count_style" style="display: inherit">
                  <el-link type="primary" @click="handleCompanyInfoOpen(scope.row.id)">{{
                    scope.row.company_name
                  }}</el-link>
                </span>
              </div>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="复制" placement="top"
              ><i
                class="el-icon-document-copy"
                style="margin-left: 0.1rem; cursor: pointer"
                @click="copySome(scope.row.company_name)"
              ></i
            ></el-tooltip>
          </template>
        </el-table-column>
        <!-- <el-table-column label="月份" fixed>
        <template slot-scope="scope">
          <el-tooltip
            :content="
              scope.row.staff_state.length > 0
                ? scope.row.staff_state[0].month
                : list_month
            "
            placement="top"
          >
            <span class="hide-style">{{
              scope.row.staff_state.length > 0
                ? scope.row.staff_state[0].month
                : list_month
            }}</span>
          </el-tooltip>
        </template>
      </el-table-column> -->
        <el-table-column label="通知状态" fixed>
          <template slot-scope="scope">
              <span class="hide-style">{{
                scope.row.staff_state.length > 0
                  ? scope.row.staff_state[0].status
                  : "未通知"
              }}</span>
          </template>
        </el-table-column>
        <el-table-column label="员工人数" width="250">
          <template slot-scope="scope">
            <el-link type="primary" @click="searchAccess(scope.row.id)"
              >共:{{ scope.row.staff_msg.total }}人 | 在职:{{
                scope.row.staff_msg.is_work ? scope.row.staff_msg.is_work : 0
              }}人 | 离职:{{
                scope.row.staff_msg.not_work ? scope.row.staff_msg.not_work : 0
              }}人
            </el-link>
          </template>
        </el-table-column>
        <el-table-column label="用户名称" width="120">
          <template slot-scope="scope">
              <span class="hide-style">{{
                scope.row.user ? scope.row.user.name : ""
              }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否关注公众号" width="120">
          <template slot-scope="scope">
              <span class="hide-style">{{
                scope.row.oauth
                  ? scope.row.oauth.subscribe === 1
                    ? "已关注"
                    : "未关注"
                  : "未关注"
              }}</span>
          </template>
        </el-table-column>
        <el-table-column label="代账软件">
          <template slot-scope="scope">
              <span class="hide-style">{{
                scope.row.com_fiscal_tax
                  ? scope.row.com_fiscal_tax.software_types
                    ? scope.row.com_fiscal_tax.software_types === 1
                      ? "17DZ"
                      : scope.row.com_fiscal_tax.software_types === 2
                      ? "云账房"
                      : scope.row.com_fiscal_tax.software_types === 3
                      ? "易代账"
                      : "其他"
                    : "未知"
                  : "无服务"
              }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="state.is_confirm"
          label="提醒企业添加员工/提醒人员"
          width="250"
        >
          <template slot-scope="scope">
            <div style="display: flex; align-items: center">
              <el-tooltip content="提醒客户添加员工" placement="top">
                <el-button
                  type="warning"
                  size="mini"
                  icon="el-icon-bell"
                  @click="handleInformAdd(scope.row, scope.$index)"
                  circle
                ></el-button>
              </el-tooltip>
              <el-avatar
                v-if="scope.row.staff_add.length > 0"
                style="
                  margin-right: 0.2rem;
                  width: 28px;
                  height: 28px;
                  margin-left: 0.2rem;
                "
                :src="
                  scope.row.staff_add.length > 0
                    ? imgPath + scope.row.staff_add[0].admin.buphoto
                    : ''
                "
              >
              </el-avatar>
              <el-tooltip
                :content="
                  scope.row.staff_add.length > 0
                    ? scope.row.staff_add[0].admin.username +
                      ' ' +
                      scope.row.staff_add[0].created_at
                    : ''
                "
                placement="top"
              >
                <div
                  style="color: #409eff; cursor: pointer"
                  @click="handleOpen(scope.row.id, scope.row.company_name, scope.$index)"
                >
                  <span class="hide-style" style="font-size: 0.1rem">
                    {{
                      scope.row.staff_add.length > 0
                        ? scope.row.staff_add[0].admin.username
                        : ""
                    }}
                  </span>
                  <span class="hide-style" style="font-size: 0.1rem">
                    {{
                      scope.row.staff_add.length > 0
                        ? scope.row.staff_add[0].created_at
                        : ""
                    }}
                  </span>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="state.month" label="工资信息通知/通知人员" width="250px">
          <template slot-scope="scope">
            <div style="display: flex; align-items: center">
              <el-tooltip content="通知客户" placement="top">
                <el-button
                  type="warning"
                  size="mini"
                  icon="el-icon-bell"
                  @click="handleInform(scope.row, scope.$index)"
                  circle
                ></el-button>
              </el-tooltip>
              <el-avatar
                v-if="scope.row.staff_info.length > 0"
                style="
                  margin-right: 0.2rem;
                  width: 28px;
                  height: 28px;
                  margin-left: 0.2rem;
                "
                :src="
                  scope.row.staff_info.length > 0
                    ? imgPath + scope.row.staff_info[0].admin.buphoto
                    : ''
                "
              >
              </el-avatar>
              <el-tooltip
                :content="
                  scope.row.staff_info.length > 0
                    ? scope.row.staff_info[0].admin.username +
                      ' ' +
                      scope.row.staff_info[0].created_at
                    : ''
                "
                placement="top"
              >
                <div
                  style="color: #409eff; cursor: pointer"
                  @click="handleOpen(scope.row.id, scope.row.company_name, scope.$index)"
                >
                  <span class="hide-style" style="font-size: 0.1rem">
                    {{
                      scope.row.staff_info.length > 0
                        ? scope.row.staff_info[0].admin.username
                        : ""
                    }}
                  </span>
                  <span class="hide-style" style="font-size: 0.1rem">
                    {{
                      scope.row.staff_info.length > 0
                        ? scope.row.staff_info[0].created_at
                        : ""
                    }}
                  </span>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="state.is_confirm" label="反馈人员" width="120">
          <template slot-scope="scope">
            <el-tooltip
              :content="
                scope.row.returnback.length > 0
                  ? (scope.row.returnback[0].user
                      ? scope.row.returnback[0].user.username
                      : '') +
                    ' ' +
                    scope.row.returnback[0].created_at
                  : ''
              "
              placement="top"
            >
              <div
                style="color: #409eff; cursor: pointer"
                @click="handleOpen(scope.row.id, scope.row.company_name, scope.$index)"
              >
                <span class="hide-style" style="font-size: 0.1rem">
                  {{
                    scope.row.returnback.length > 0
                      ? scope.row.returnback[0].user
                        ? scope.row.returnback[0].user.username
                        : ""
                      : ""
                  }}
                </span>
                <span class="hide-style" style="font-size: 0.1rem">
                  {{
                    scope.row.returnback.length > 0
                      ? scope.row.returnback[0].created_at
                      : ""
                  }}
                </span>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="state.is_confirm" label="确认人员" width="120">
          <template slot-scope="scope">
            <el-tooltip
              :content="
                scope.row.makesure.length > 0
                  ? (scope.row.makesure[0].user
                      ? scope.row.makesure[0].user.username
                      : scope.row.makesure[0].admin
                      ? scope.row.makesure[0].admin.username
                      : '') +
                    ' ' +
                    scope.row.makesure[0].created_at
                  : ''
              "
              placement="top"
            >
              <div
                style="color: #409eff; cursor: pointer"
                @click="handleOpen(scope.row.id, scope.row.company_name, scope.$index)"
              >
                <span class="hide-style" style="font-size: 0.1rem">
                  {{
                    scope.row.makesure.length > 0
                      ? scope.row.makesure[0].user
                        ? scope.row.makesure[0].user.username
                        : scope.row.makesure[0].admin
                        ? scope.row.makesure[0].admin.username
                        : ""
                      : ""
                  }}
                </span>
                <span class="hide-style" style="font-size: 0.1rem">
                  {{
                    scope.row.makesure.length > 0 ? scope.row.makesure[0].created_at : ""
                  }}
                </span>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="社保上传/社保上传人员" width="260">
          <template slot-scope="scope">
            <div style="display: flex; align-items: center">
              <el-tooltip content="上传图片" placement="top">
                <el-button
                  type="success"
                  size="mini"
                  icon="el-icon-upload2"
                  @click="handleUploadImg(scope.row, scope.$index, 5)"
                  circle
                ></el-button>
              </el-tooltip>
              <el-tooltip
                content="查看图片"
                placement="top"
                v-if="scope.row.staff_secuity.length > 0"
              >
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-picture-outline"
                  @click="handleOpen(scope.row.id, scope.row.company_name, scope.$index)"
                  circle
                ></el-button>
              </el-tooltip>
              <el-avatar
                v-if="scope.row.staff_secuity.length > 0"
                style="
                  margin-right: 0.2rem;
                  width: 28px;
                  height: 28px;
                  margin-left: 0.2rem;
                "
                :src="
                  scope.row.staff_secuity.length > 0
                    ? imgPath + scope.row.staff_secuity[0].admin.buphoto
                    : scope.row.staff_secuity[0]
                    ? imgPath + scope.row.staff_secuity[0].admin.buphoto
                    : ''
                "
              >
              </el-avatar>
              <el-tooltip
                :content="
                  scope.row.staff_secuity.length > 0
                    ? scope.row.staff_secuity[0].admin.username +
                      ' ' +
                      scope.row.staff_secuity[0].created_at
                    : ''
                "
                placement="top"
              >
                <div>
                  <span class="hide-style" style="font-size: 0.1rem">
                    {{
                      scope.row.staff_secuity.length > 0
                        ? scope.row.staff_secuity[0].admin.username
                        : ""
                    }}
                  </span>
                  <span class="hide-style" style="font-size: 0.1rem">
                    {{
                      scope.row.staff_secuity.length > 0
                        ? scope.row.staff_secuity[0].created_at
                        : ""
                    }}
                  </span>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="公积金上传/公积金上传人员" width="260">
          <template slot-scope="scope">
            <div style="display: flex; align-items: center">
              <el-tooltip content="上传图片" placement="top">
                <el-button
                  type="success"
                  size="mini"
                  icon="el-icon-upload2"
                  @click="handleUploadImg(scope.row, scope.$index, 6)"
                  circle
                ></el-button>
              </el-tooltip>
              <el-tooltip
                content="查看图片"
                placement="top"
                v-if="scope.row.staff_accum.length > 0"
              >
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-picture-outline"
                  @click="handleOpen(scope.row.id, scope.row.company_name, scope.$index)"
                  circle
                ></el-button>
              </el-tooltip>
              <el-avatar
                v-if="scope.row.staff_accum.length > 0"
                style="
                  margin-right: 0.2rem;
                  width: 28px;
                  height: 28px;
                  margin-left: 0.2rem;
                "
                :src="
                  scope.row.staff_accum.length > 0
                    ? imgPath + scope.row.staff_accum[0].admin.buphoto
                    : scope.row.staff_accum[0]
                    ? imgPath + scope.row.staff_accum[0].admin.buphoto
                    : ''
                "
              >
              </el-avatar>
              <el-tooltip
                :content="
                  scope.row.staff_accum.length > 0
                    ? scope.row.staff_accum[0].admin.username +
                      ' ' +
                      scope.row.staff_accum[0].created_at
                    : ''
                "
                placement="top"
              >
                <div>
                  <span class="hide-style" style="font-size: 0.1rem">
                    {{
                      scope.row.staff_accum.length > 0
                        ? scope.row.staff_accum[0].admin.username
                        : ""
                    }}
                  </span>
                  <span class="hide-style" style="font-size: 0.1rem">
                    {{
                      scope.row.staff_accum.length > 0
                        ? scope.row.staff_accum[0].created_at
                        : ""
                    }}
                  </span>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="320">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="员工档案" placement="top">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-share"
                circle
                @click="searchAccess(scope.row.id, scope.$index)"
              ></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="服务记录" placement="top">
              <el-button
                type="primary"
                @click="handleOpen(scope.row.id, scope.row.company_name, scope.$index)"
                size="mini"
                icon="el-icon-user"
                circle
              ></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="财税建议" placement="top">
              <el-button
                type="primary"
                @click="
                  handleOpenAdvice(scope.row.id, scope.row.company_name, scope.$index)
                "
                size="mini"
                icon="el-icon-reading"
                circle
              ></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="聊天记录" placement="top">
              <el-button
                type="primary"
                :disabled="scope.row.chat_com ? false : true"
                @click="handleChatOpen(scope.row.chat_com, scope.row.company_name)"
                size="mini"
                icon="el-icon-s-comment"
                circle
              ></el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="企业微信群聊天记录"
              placement="top"
            >
              <el-button
                type="warning"
                :disabled="scope.row.wx_work_chat_com ? false : true"
                @click="
                  handleWxChatOpen(scope.row.wx_work_chat_com, scope.row.company_name)
                "
                size="mini"
                icon="el-icon-s-comment"
                circle
              ></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="企友聊天记录" placement="top">
              <el-button
                type="success"
                :disabled="scope.row.qy_chat_com ? false : true"
                size="mini"
                icon="el-icon-s-comment"
                @click="handleQyChatOpen(scope.row.qy_chat_com, scope.row.company_name)"
                circle
              ></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="电话联系记录" placement="top">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-phone-outline
"
                :disabled="scope.row.user ? false : true"
                circle
                @click="handCallLogsOpen(scope.row)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-main>

    <el-footer class="footer-style">
      <el-pagination
        background
        class="text-r mt-10"
        layout="total, sizes, prev, pager, next, jumper"
        :hide-on-single-page="true"
        :current-page="pageOption.currentPage"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="pageOption.pageSize"
        :total="pageOption.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </el-footer>

    <el-drawer
      :title="
        (addForm.type === 5 ? '社保上传' : '公积金上传') + '【' + companyName + '】'
      "
      :visible.sync="uploadingDrawer"
      :before-close="handleAddClose"
      size="40%"
    >
      <div class="drawer-content">
        <el-form
          :model="addForm"
          :rules="addRules"
          ref="addForm"
          label-width="100px"
          size="mini"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="月份" prop="month">
                <el-date-picker
                  v-model="addForm.month"
                  type="month"
                  size="mini"
                  width="100%"
                  readonly
                  format="yyyy 年 MM 月"
                  value-format="yyyy-MM"
                  @change="pickerDataChangeUpload"
                  placeholder="选择月"
                >
                </el-date-picker> </el-form-item
              >`
            </el-col>
          </el-row>
          <el-form-item label="备注" prop="user_remark">
            <el-input
              v-model="addForm.remark"
              type="textarea"
              placeholder="请输入需要告知客户的信息(若无 可不填写)"
            />
          </el-form-item>
        </el-form>
        <el-row>
          <el-col :span="24">
            <el-card shadow="hover">
              <el-upload
                multiple
                ref="upload"
                action="#"
                accept="image/png, image/jpeg, image/gif"
                :limit="5"
                :on-preview="handleLicensePreview"
                :on-change="handleLicenseChange"
                :on-remove="handleLicenseRemove"
                :file-list="licenseList"
                list-type="picture"
                :auto-upload="false"
              >
                <el-link slot="trigger" type="primary">上传截图(最多可上传5张)</el-link>
              </el-upload>
            </el-card>
          </el-col>
        </el-row>
        <el-row class="mt-10">
          <el-input
            v-paste="handleParse"
            type="textarea"
            placeholder="请点击此处，再粘贴复制的截图"
          />
        </el-row>
        <el-row class="mt-10">
          <el-col :span="24" class="text-r">
            <el-button type="primary" size="mini" @click="submitAddUpload('addForm')"
              >添加</el-button
            >
          </el-col>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
      :title="'服务记录【' + companyName + '】'"
      :visible.sync="serviceDrawer"
      direction="rtl"
      size="55%"
      :before-close="handleServiceBeforeClose"
      fullscreen
    >
      <div style="margin-left: 0.4rem">
        <div class="m-tabs-content">
          <div class="blocka">
            <el-tabs v-model="showTabPane" type="border-card">
              <el-tab-pane label="服务记录" name="first">
                <el-collapse
                  v-model="activeName"
                  v-for="(records, index) in infoRecord"
                  :key="index"
                  accordion
                  style="border-bottom: 1px solid #ebeef5"
                >
                  <el-collapse-item
                    :title="records.month + ' 员工服务详情'"
                    :name="index + 1"
                  >
                    <el-timeline>
                      <el-timeline-item
                        :timestamp="item.created_at"
                        v-for="(item, index) in records.record"
                        :key="index"
                        placement="top"
                      >
                        <el-card>
                          <h4>
                            <el-row>
                              <el-col :span="20">
                                {{
                                  (item.admin
                                    ? item.admin.username
                                    : item.user.username) +
                                  (item.type === 1
                                    ? "添加员工提醒"
                                    : item.type === 2
                                    ? " 的员工信息提醒"
                                    : item.type === 3 || item.type === 6
                                    ? " 增改了员工信息"
                                    : item.type === 4
                                    ? " 确认了员工信息"
                                    : item.type === 5
                                    ? " 上传了员工社保信息"
                                    : "上传了员工公积金信息")
                                }}
                              </el-col>
                              <el-col :span="4" v-if="item.is_sure">
                                <span v-if="item.is_sure === 1"
                                  ><el-button
                                    type="warning"
                                    size="mini"
                                    style="float: right"
                                    @click="handleSureChange(item.id)"
                                    >待确认</el-button
                                  ></span
                                >
                                <span v-if="item.is_sure === 2"
                                  ><el-button
                                    type="success"
                                    size="mini"
                                    disabled
                                    style="float: right"
                                    >已确认</el-button
                                  ></span
                                >
                              </el-col>
                            </el-row>
                          </h4>
                          <span v-if="item.images">
                            <span v-for="(imgUrl, index) in item.images" :key="index">
                              <el-image
                                class="image"
                                :src="imgUrl"
                                :preview-src-list="item.images"
                                v-if="item.images"
                                style="margin-right: 0.1rem"
                              ></el-image>
                            </span>
                          </span>
                          <p v-if="item.remark">备注：{{ item.remark }}</p>
                          <p v-if="!item.remark">备注：无</p>
                        </el-card>
                      </el-timeline-item>
                    </el-timeline>
                  </el-collapse-item>
                </el-collapse>
              </el-tab-pane>
              <!--<el-tab-pane label="员工信息" name="second">-->
              <!--<el-row style="margin-bottom: 0.1rem">-->
              <!--<el-col :span="12" class="m-label" style="color: #409eff"-->
              <!--&gt;{{ companyName }}（员工信息表）</el-col-->
              <!--&gt;-->
              <!--<el-col :span="8" class="m-label">-->
              <!--共：{{ staffCount.total }}人 在职：{{-->
              <!--staffCount.is_work-->
              <!--}}-->
              <!--离职：{{ staffCount.not_work }}-->
              <!--</el-col>-->
              <!--<el-col :span="4" class="text-r" style="color: #409eff">-->
              <!--&lt;!&ndash;批量&ndash;&gt;-->
              <!--<el-button-->
              <!--type="primary"-->
              <!--icon="el-icon-help"-->
              <!--circle-->
              <!--size="mini"-->
              <!--@click="handlebatchStaff(addStaffsFrom.company_id, companyName)"-->
              <!--&gt;</el-button>-->
              <!--<el-button-->
              <!--type="primary"-->
              <!--icon="el-icon-circle-plus"-->
              <!--circle-->
              <!--size="mini"-->
              <!--@click="handleAddStaffOpen"-->
              <!--&gt;</el-button>-->
              <!--</el-col>-->
              <!--</el-row>-->
              <!--<el-table-->
              <!--:data="tableData"-->
              <!--style="width: 100%"-->
              <!--border-->
              <!--max-height="700"-->
              <!--&gt;-->
              <!--<el-table-column label="员工姓名">-->
              <!--<template slot-scope="scope">-->
              <!--<el-tooltip-->
              <!--:content="scope.row.staff_name"-->
              <!--placement="top"-->
              <!--&gt;-->
              <!--<div class="company_hover">-->
              <!--<span class="count_style" style="display: inherit">-->
              <!--<el-link-->
              <!--type="primary"-->
              <!--@click="handleOpenStaffDetail(scope.row)"-->
              <!--&gt;{{ scope.row.staff_name }}</el-link-->
              <!--&gt;-->
              <!--</span>-->
              <!--</div>-->
              <!--</el-tooltip>-->
              <!--</template>-->
              <!--</el-table-column>-->
              <!--<el-table-column label="入职时间" width="100">-->
              <!--<template slot-scope="scope">-->
              <!--<el-tooltip-->
              <!--:content="scope.row.staff_reg_at"-->
              <!--placement="top"-->
              <!--&gt;-->
              <!--<span>{{ scope.row.staff_reg_at }}</span>-->
              <!--</el-tooltip>-->
              <!--</template>-->
              <!--</el-table-column>-->
              <!--<el-table-column label="性别" width="100">-->
              <!--<template slot-scope="scope">-->
              <!--<el-tooltip-->
              <!--:content="scope.row.gender"-->
              <!--placement="top"-->
              <!--&gt;-->
              <!--<span>{{ scope.row.gender }}</span>-->
              <!--</el-tooltip>-->
              <!--</template>-->
              <!--</el-table-column>-->
              <!--<el-table-column label="出生日期" width="100">-->
              <!--<template slot-scope="scope">-->
              <!--<el-tooltip-->
              <!--:content="scope.row.birthday"-->
              <!--placement="top"-->
              <!--&gt;-->
              <!--<span>{{ scope.row.birthday }}</span>-->
              <!--</el-tooltip>-->
              <!--</template>-->
              <!--</el-table-column>-->
              <!--<el-table-column label="国籍" width="100">-->
              <!--<template slot-scope="scope">-->
              <!--<el-tooltip-->
              <!--:content="scope.row.nationality"-->
              <!--placement="top"-->
              <!--&gt;-->
              <!--<span>{{ scope.row.nationality }}</span>-->
              <!--</el-tooltip>-->
              <!--</template>-->
              <!--</el-table-column>-->
              <!--<el-table-column label="是否在职">-->
              <!--<template slot-scope="scope">-->
              <!--<el-tooltip-->
              <!--:content="-->
              <!--scope.row.is_inservice === 1 ? '在职' : '已离职'-->
              <!--"-->
              <!--placement="top"-->
              <!--&gt;-->
              <!--<span>{{-->
              <!--scope.row.is_inservice === 1 ? "在职" : "已离职"-->
              <!--}}</span>-->
              <!--</el-tooltip>-->
              <!--</template>-->
              <!--</el-table-column>-->
              <!--<el-table-column label="员工工资（￥）" width="130">-->
              <!--<template slot-scope="scope">-->
              <!--<el-tooltip-->
              <!--:content="scope.row.staff_salary"-->
              <!--placement="top"-->
              <!--&gt;-->
              <!--<span>{{ scope.row.staff_salary }}</span>-->
              <!--</el-tooltip>-->
              <!--</template>-->
              <!--</el-table-column>-->
              <!--<el-table-column label="社保缴纳">-->
              <!--<template slot-scope="scope">-->
              <!--<el-tooltip-->
              <!--:content="scope.row.is_secuity === 1 ? '否' : '是'"-->
              <!--placement="top"-->
              <!--&gt;-->
              <!--<span>{{-->
              <!--scope.row.is_secuity === 1 ? "否" : "是"-->
              <!--}}</span>-->
              <!--</el-tooltip>-->
              <!--</template>-->
              <!--</el-table-column>-->
              <!--<el-table-column label="公积金缴纳" width="130">-->
              <!--<template slot-scope="scope">-->
              <!--<el-tooltip-->
              <!--:content="scope.row.is_accum === 1 ? '否' : '是'"-->
              <!--placement="top"-->
              <!--&gt;-->
              <!--<span>{{-->
              <!--scope.row.is_accum === 1 ? "否" : "是"-->
              <!--}}</span>-->
              <!--</el-tooltip>-->
              <!--</template>-->
              <!--</el-table-column>-->
              <!--<el-table-column label="操作">-->
              <!--<template slot-scope="scope">-->
              <!--<el-link-->
              <!--type="primary"-->
              <!--@click="handleStaffUpdateOpen(scope.row, scope.$index)"-->
              <!--&gt;修改</el-link-->
              <!--&gt;-->
              <!--</template>-->
              <!--</el-table-column>-->
              <!--</el-table>-->
              <!--</el-tab-pane>-->
            </el-tabs>
          </div>
        </div>
      </div>
    </el-drawer>
    <el-drawer
      :title="'员工详情【' + companyName + '】'"
      :visible.sync="staffDrawer"
      size="50%"
    >
      <div style="margin-left: 0.4rem">
        <div class="m-tabs-content">
          <div class="blocka">
            <el-tabs v-model="showStaffPane" type="border-card">
              <el-tab-pane
                :label="companyName + '（' + StaffDetail.staff_name + '）'"
                name="first"
              >
                <div class="m-label" style="margin-bottom: 0.2rem; margin-top: 0.2rem">
                  员工基本信息
                </div>
                <div style="border: solid 1px #eeeeee; border-radius: 10px; color: gray">
                  <div style="margin-left: 0.2rem; margin-top: 0.2rem">
                    <el-row class="m-label">
                      <!-- 第一行 -->
                      <el-col :span="12">
                        <el-col :span="6">员工姓名：</el-col>
                        <el-col :span="18">{{ StaffDetail.staff_name }}</el-col>
                      </el-col>
                      <el-col :span="12">
                        <el-col :span="6">员工工资：</el-col>
                        <el-col :span="18">{{ StaffDetail.staff_salary }}</el-col>
                      </el-col>
                      <!-- 第二行 -->
                      <el-col :span="12">
                        <el-col :span="6">社保：</el-col>
                        <el-col :span="18">{{
                          StaffDetail.is_secuity === 1 ? "不缴纳" : "缴纳"
                        }}</el-col>
                      </el-col>
                      <el-col :span="12">
                        <el-col :span="6">公积金：</el-col>
                        <el-col :span="18">{{
                          StaffDetail.is_accum === 1 ? "不缴纳" : "缴纳"
                        }}</el-col>
                      </el-col>
                      <!-- 第三行 -->
                      <el-col :span="12">
                        <el-col :span="6">手机号码：</el-col>
                        <el-col :span="18">{{ StaffDetail.staff_phone }}</el-col>
                      </el-col>
                      <el-col :span="12">
                        <el-col :span="6">身份证号：</el-col>
                        <el-col :span="18">{{ StaffDetail.staff_id_number }}</el-col>
                      </el-col>
                      <!-- 第四行 -->
                      <el-col :span="12">
                        <el-col :span="6">入职时间：</el-col>
                        <el-col :span="18">{{ StaffDetail.staff_reg_at }}</el-col>
                      </el-col>
                      <el-col :span="12">
                        <el-col :span="6">是否在职：</el-col>
                        <el-col :span="18">{{
                          StaffDetail.is_inservice === 1 ? "在职" : "离职"
                        }}</el-col>
                      </el-col>
                      <!-- 第五行 -->
                      <el-col :span="12">
                        <el-col :span="6">性别：</el-col>
                        <el-col :span="18">{{ StaffDetail.gender }}</el-col>
                      </el-col>
                      <el-col :span="12">
                        <el-col :span="6">出生日期：</el-col>
                        <el-col :span="18">{{ StaffDetail.birthday }}</el-col>
                      </el-col>
                      <!-- 第六行 -->
                      <el-col :span="12">
                        <el-col :span="6">国籍：</el-col>
                        <el-col :span="18">{{ StaffDetail.nationality }}</el-col>
                      </el-col>
                    </el-row>
                  </div>
                </div>
                <div
                  class="m-label"
                  style="margin-bottom: 0.2rem; margin-top: 0.2rem"
                  v-if="StaffDetail.secuity && StaffDetail.is_secuity === 2"
                >
                  员工社保信息
                </div>
                <div
                  style="border: solid 1px #eeeeee; border-radius: 10px; color: gray"
                  v-if="StaffDetail.secuity && StaffDetail.is_secuity === 2"
                >
                  <div style="margin-left: 0.2rem; margin-top: 0.2rem">
                    <el-row class="m-label">
                      <!-- 第一行 -->
                      <el-col :span="24">
                        <el-col :span="6">社保基数(￥)：</el-col>
                        <el-col :span="18">{{
                          StaffDetail.secuity ? StaffDetail.secuity.secuity_base : "0.00"
                        }}</el-col>
                      </el-col>
                      <el-col :span="24">
                        <el-col :span="6">现居地址：</el-col>
                        <el-col :span="18">{{
                          StaffDetail.secuity ? StaffDetail.secuity.address : ""
                        }}</el-col>
                      </el-col>
                    </el-row>
                    <el-row v-if="StaffDetail.src_list">
                      <el-col
                        :span="11"
                        v-for="(idMsg, index) in StaffDetail.src_list"
                        :key="index"
                      >
                        <el-image
                          style="width: 100%; height: 200px; border-radius; 5px;"
                          :src="idMsg"
                          :preview-src-list="StaffDetail.src_list"
                        ></el-image>
                      </el-col>
                    </el-row>
                  </div>
                </div>
                <div
                  class="m-label"
                  style="margin-bottom: 0.2rem; margin-top: 0.2rem"
                  v-if="StaffDetail.accum && StaffDetail.is_accum === 2"
                >
                  员工社保信息
                </div>
                <div
                  style="border: solid 1px #eeeeee; border-radius: 10px; color: gray"
                  v-if="StaffDetail.accum && StaffDetail.is_accum === 2"
                >
                  <div style="margin-left: 0.2rem; margin-top: 0.2rem">
                    <el-row class="m-label">
                      <!-- 第一行 -->
                      <el-col :span="24">
                        <el-col :span="6">公积金基数(￥)：</el-col>
                        <el-col :span="18">{{
                          StaffDetail.accum ? StaffDetail.accum.accum_base : "0.00"
                        }}</el-col>
                      </el-col>
                      <el-col :span="24">
                        <el-col :span="6">公积金账号：</el-col>
                        <el-col :span="18">{{
                          StaffDetail.accum ? StaffDetail.accum.accum_account : ""
                        }}</el-col>
                      </el-col>
                    </el-row>
                  </div>
                </div>
                <div style="height: 50px"></div>
              </el-tab-pane>
              <el-tab-pane label="修改记录" name="second">
                <div class="block">
                  <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
                    <el-timeline v-for="(record, index) in StaffRecords" :key="index">
                      <el-timeline-item :timestamp="record.created_at" placement="top">
                        <el-card>
                          <p>{{ record.operate }}</p>
                        </el-card>
                      </el-timeline-item>
                    </el-timeline>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </el-drawer>
    <el-dialog title="批量通知" :visible.sync="batchDialog" width="30%">
      <el-date-picker
        v-model="dateTime"
        type="month"
        size="mini"
        format="yyyy 年 MM 月"
        value-format="yyyy-MM"
        :picker-options="pickerOptions"
        placeholder="选择月份"
      >
      </el-date-picker>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="batchDialog = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="batchSendInform">确 定</el-button>
      </span>
    </el-dialog>
    <el-drawer
      title="聊天记录"
      :visible.sync="chatDrawer"
      direction="rtl"
      :before-close="handleChatBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <chat :chatId="chatId" :chatName="chatName"></chat>
      </div>
    </el-drawer>
    <el-drawer
      title="企业微信聊天记录"
      :visible.sync="wxChatDrawer"
      direction="rtl"
      :before-close="handleWxChatBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <wx-work-chat :chatId="wxWorkChatId" :chatName="wxchatName"></wx-work-chat>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
      title="电话联系记录"
      :visible.sync="callLogsDrawer"
      direction="rtl"
      :before-close="handleCallLogsBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <call-logs
            :company="company"
            :phone="callPhone"
            :phone1="callPhone1"
            :phone2="callPhone2"
            :phone3="callPhone3"
          ></call-logs>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
      title="聊天记录"
      :visible.sync="qyChatDrawer"
      direction="rtl"
      :before-close="handleQyChatBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <qy-group-chat :chatId="qyChatId" :chatName="qyChatName"></qy-group-chat>
      </div>
    </el-drawer>
    <el-drawer
      :title="'添加员工 【' + companyName + '】'"
      :visible.sync="addStaffDrawer"
      direction="rtl"
      :before-close="handleAddStaffBeforeClose"
      size="55%"
    >
      <div class="m-tabs-content my_style" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-tabs v-model="showNewTabPane" :tab-position="tabPosition" type="border-card">
          <el-tab-pane name="first" label="基本信息">
            <el-form
              ref="addStaffsFrom"
              :rules="addStaffRules"
              :model="addStaffsFrom"
              label-width="100px"
              size="mini"
            >
              <div style="margin-left: 70%">
                人员状态：
                <el-radio-group size="mini" v-model="addStaffsFrom.is_inservice">
                  <el-radio-button :value="1" :label="1">在职</el-radio-button>
                  <el-radio-button :value="2" :label="2">离职</el-radio-button>
                </el-radio-group>
              </div>
              <div class="dplx-item-title item-title small v-ewp-dc49ea38">基础信息</div>
              <el-form-item label="姓名：" prop="staff_name">
                <el-input v-model="addStaffsFrom.staff_name"></el-input>
              </el-form-item>
              <el-form-item label="工号：" prop="work_nnumber">
                <el-input v-model="addStaffsFrom.work_nnumber"></el-input>
              </el-form-item>
              <el-form-item label="证件类型：" prop="number_type">
                <el-select v-model="addStaffsFrom.number_type" size="mini" clearable>
                  <el-option :value="1" label="居民身份证"></el-option>
                  <el-option :value="2" label="外国护照"></el-option>
                  <el-option :value="3" label="港澳居民来往内地通行证"></el-option>
                  <el-option :value="4" label="台湾居民来往大陆通行证"></el-option>
                  <el-option
                    :value="5"
                    label="外国人永久居留身份证(外国人永久居留证)"
                  ></el-option>
                  <el-option :value="6" label="中华人民共和国港澳居民居住证"></el-option>
                  <el-option :value="7" label="中华人民共和国台湾居民居住证"></el-option>
                  <el-option
                    :value="8"
                    label="中华人民共和国外国人工作许可证(A类)"
                  ></el-option>
                  <el-option
                    :value="9"
                    label="中华人民共和国外国人工作许可证(B类)"
                  ></el-option>
                  <el-option
                    :value="10"
                    label="中华人民共和国外国人工作许可证(C类)"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="证件号码：" prop="staff_id_number">
                <el-input v-model="addStaffsFrom.staff_id_number"></el-input>
              </el-form-item>
              <el-form-item label="其他证件类型：" prop="qt_number_type">
                <el-select v-model="addStaffsFrom.qt_number_type" size="mini" clearable>
                  <el-option :value="1" label="外国护照"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="其他证件证件号码：" prop="qt_staff_id_number">
                <el-input v-model="addStaffsFrom.qt_staff_id_number"></el-input>
              </el-form-item>
              <el-form-item label="任职受雇从业类型：" prop="type_employment">
                <el-select v-model="addStaffsFrom.type_employment" size="mini" clearable>
                  <el-option :value="1" label="雇员"></el-option>
                  <el-option :value="2" label="保险营销员"></el-option>
                  <el-option :value="3" label="证券经纪人"></el-option>
                  <el-option :value="4" label="实习学生(全日制学历教育)"></el-option>
                  <el-option :value="5" label="其他"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="入职年度就业情形：" prop="employment_situation">
                <el-select
                  v-model="addStaffsFrom.employment_situation"
                  size="mini"
                  clearable
                >
                  <el-option :value="1" label="当年首次入职其他人员"></el-option>
                  <el-option :value="2" label="保险营销员"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="手机号码：" prop="staff_phone">
                <el-input v-model="addStaffsFrom.staff_phone"></el-input>
              </el-form-item>
              <el-form-item label="国籍：" prop="nationality">
                <el-input v-model="addStaffsFrom.nationality"></el-input>
              </el-form-item>
              <el-form-item label="出生日期：" prop="birthday">
                <el-date-picker
                  v-model="addStaffsFrom.birthday"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="出生日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="性别：" prop="gender">
                <el-select v-model="addStaffsFrom.gender" size="mini" clearable>
                  <el-option :value="1" label="男"></el-option>
                  <el-option :value="2" label="女"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="入职时间：" prop="staff_reg_at">
                <el-date-picker
                  v-model="addStaffsFrom.staff_reg_at"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择入职时间"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="是否扣除减除费用：" prop="deduction_expenses">
                <el-select
                  v-model="addStaffsFrom.deduction_expenses"
                  size="mini"
                  clearable
                >
                  <el-option :value="1" label="是"></el-option>
                  <el-option :value="2" label="否"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="离职时间：" prop="staff_leave_at">
                <el-date-picker
                  v-model="addStaffsFrom.staff_leave_at"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择离职时间"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="籍贯：" prop="native_place">
                <el-input v-model="addStaffsFrom.native_place"></el-input>
              </el-form-item>
              <el-form-item label="婚姻状态：" prop="marital_status">
                <el-select v-model="addStaffsFrom.marital_status" size="mini" clearable>
                  <el-option :value="1" label="是"></el-option>
                  <el-option :value="2" label="否"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="政治面貌：" prop="political_status">
                <el-select v-model="addStaffsFrom.political_status" size="mini" clearable>
                  <el-option :value="1" label="是"></el-option>
                  <el-option :value="2" label="否"></el-option>
                </el-select>
              </el-form-item>
              <el-button
                type="primary"
                @click="submitAddStaff"
                size="mini"
                style="margin: 20px; margin-left: 50%"
                >保 存1</el-button
              >
            </el-form>
          </el-tab-pane>
          <el-tab-pane name="in_office" label="任职信息">
            <div class="dplx-item-title item-title">任职信息</div>
            <el-form
              ref="addInOfficeFrom"
              :rules="addInOfficeFromRules"
              :model="addInOfficeFrom"
              label-width="100px"
              size="mini"
            >
              <el-form-item label="员工类型：" prop="type_employee">
                <el-select v-model="addInOfficeFrom.type_employee" size="mini" clearable>
                  <el-option :value="1" label="管理人员"></el-option>
                  <el-option :value="2" label="销售人员"></el-option>
                  <el-option :value="3" label="研发人员"></el-option>
                  <el-option :value="4" label="车间人员"></el-option>
                  <el-option :value="5" label="临时人员"></el-option>
                  <el-option :value="6" label="普通人员"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="组别：" prop="employees_group">
                <el-input v-model="addInOfficeFrom.employees_group"></el-input>
              </el-form-item>
              <el-form-item label="岗位：" prop="jobs">
                <el-input v-model="addInOfficeFrom.jobs"></el-input>
              </el-form-item>
              <el-form-item label="工作性质：" prop="nature_work">
                <el-select v-model="addInOfficeFrom.nature_work" size="mini" clearable>
                  <el-option :value="1" label="全职"></el-option>
                  <el-option :value="2" label="兼职"></el-option>
                  <el-option :value="3" label="实习"></el-option>
                  <el-option :value="4" label="劳务"></el-option>
                  <el-option :value="5" label="劳务派遣"></el-option>
                  <el-option :value="6" label="退休返聘"></el-option>
                  <el-option :value="7" label="合同工"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="工龄：" prop="length_service">
                <el-input v-model="addInOfficeFrom.length_service"></el-input>
              </el-form-item>
              <el-form-item label="试用状态：" prop="trial_status">
                <el-select v-model="addInOfficeFrom.trial_status" size="mini" clearable>
                  <el-option :value="1" label="适用中"></el-option>
                  <el-option :value="2" label="已转正"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="试用期：" prop="probation_period">
                <el-select
                  v-model="addInOfficeFrom.probation_period"
                  size="mini"
                  clearable
                >
                  <el-option :value="0" label="无试用期"></el-option>
                  <el-option :value="1" label="一个月"></el-option>
                  <el-option :value="2" label="二个月"></el-option>
                  <el-option :value="3" label="三个月"></el-option>
                  <el-option :value="4" label="四个月"></el-option>
                  <el-option :value="5" label="五个月"></el-option>
                  <el-option :value="6" label="六个月"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="转正日期：" prop="date_conversion">
                <el-date-picker
                  v-model="addInOfficeFrom.date_conversion"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="转正日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="QQ号码：" prop="qq_number">
                <el-input v-model="addInOfficeFrom.qq_number"></el-input>
              </el-form-item>
              <el-form-item label="紧急联系人：" prop="emergency_person">
                <el-input v-model="addInOfficeFrom.emergency_person"></el-input>
              </el-form-item>
              <el-form-item label="紧急联系电话：" prop="emergency_phone">
                <el-input v-model="addInOfficeFrom.emergency_phone"></el-input>
              </el-form-item>
              <el-form-item label="薪资停发月份：" prop="salary_suspension">
                <el-date-picker
                  v-model="addInOfficeFrom.salary_suspension"
                  type="month"
                  placeholder="薪资停发月份"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="社保停缴月份：" prop="club_discontinuation">
                <el-date-picker
                  v-model="addInOfficeFrom.club_discontinuation"
                  type="month"
                  placeholder="社保停缴月份"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="公积金停缴月份：" prop="provident_discontinuation">
                <el-date-picker
                  v-model="addInOfficeFrom.provident_discontinuation"
                  type="month"
                  placeholder="公积金停缴月份"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="离职性质：" prop="nature_resignation">
                <el-select
                  v-model="addInOfficeFrom.nature_resignation"
                  size="mini"
                  clearable
                >
                  <el-option :value="1" label="家庭原因"></el-option>
                  <el-option :value="2" label="身体原因"></el-option>
                  <el-option :value="3" label="薪资原因"></el-option>
                  <el-option :value="4" label="交通不便"></el-option>
                  <el-option :value="5" label="工作压力"></el-option>
                  <el-option :value="6" label="管理问题"></el-option>
                  <el-option :value="7" label="无晋升机会"></el-option>
                  <el-option :value="8" label="职业规划"></el-option>
                  <el-option :value="9" label="合同到期放弃续约"></el-option>
                  <el-option :value="10" label="试用期内辞职"></el-option>
                  <el-option :value="11" label="违反工商条例"></el-option>
                  <el-option :value="12" label="组织调整/裁员"></el-option>
                  <el-option :value="13" label="业绩不达标辞退"></el-option>
                  <el-option :value="14" label="其他原因"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="离职原因：" prop="reasons_leaving">
                <el-input v-model="addInOfficeFrom.reasons_leaving"></el-input>
              </el-form-item>
              <el-button
                type="primary"
                @click="submitAddForm('addInOfficeFrom')"
                size="mini"
                style="margin: 20px; margin-left: 50%"
                >保 存2</el-button
              >
            </el-form>
          </el-tab-pane>
          <el-tab-pane name="securityd_accum" label="社保公积金">
            <div class="dplx-item-title item-title">社保公积金</div>
            <el-form
              ref="addSocialSecurityFrom"
              :model="addSocialSecurityFrom"
              label-width="100px"
              size="mini"
            >
              <el-form-item label="参保方案：" prop="insurance_scheme">
                <el-select
                  v-model="addSocialSecurityFrom.insurance_scheme"
                  size="mini"
                  clearable
                >
                  <el-option :value="1" label="上海社保工商0.16%"></el-option>
                  <el-option :value="2" label="上海社保工商00.256%"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="参保城市：" prop="insured_city">
                <el-input v-model="addSocialSecurityFrom.insured_city"></el-input>
              </el-form-item>
              <el-form-item label="户籍性质：" prop="registered_the">
                <el-select
                  v-model="addSocialSecurityFrom.registered_the"
                  size="mini"
                  clearable
                >
                  <el-option :value="1" label="城镇户籍"></el-option>
                  <el-option :value="2" label="农村户籍"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="是否缴纳社保："
                prop="is_secuity"
                style="width: 100% !important"
              >
                <el-radio-group v-model="addSocialSecurityFrom.is_secuity" size="mini">
                  <el-radio :label="2" border>是</el-radio>
                  <el-radio :label="1" border>否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="人社证件类型：" prop="staff_id_type">
                <el-select
                  v-model="addSocialSecurityFrom.staff_id_type"
                  size="mini"
                  clearable
                >
                  <el-option :value="1" label="居民身份证"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="人社证件号码：" prop="staff_id_number">
                <el-input v-model="addSocialSecurityFrom.staff_id_number"></el-input>
              </el-form-item>
              <el-form-item label="开始参保月份：" prop="month_enrollment">
                <el-date-picker
                  v-model="addSocialSecurityFrom.month_enrollment"
                  type="month"
                  placeholder="开始参保月份"
                  :disabled="addSocialSecurityFrom.is_secuity === 1 ? true : false"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="社保停缴月份：" prop="ting_month_enrollment">
                <el-date-picker
                  v-model="addSocialSecurityFrom.ting_month_enrollment"
                  type="month"
                  placeholder="社保停缴月份"
                  :disabled="addSocialSecurityFrom.is_secuity === 1 ? true : false"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="社保补缴月份：" prop="bu_month_enrollment">
                <el-date-picker
                  v-model="addSocialSecurityFrom.bu_month_enrollment"
                  type="month"
                  placeholder="社保补缴月份"
                  :disabled="addSocialSecurityFrom.is_secuity === 1 ? true : false"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="社保账号：" prop="security_number">
                <el-input
                  v-model="addSocialSecurityFrom.security_number"
                  :disabled="addSocialSecurityFrom.is_secuity === 1 ? true : false"
                ></el-input>
              </el-form-item>
              <el-form-item label="社保个人编号：" prop="security_personal_number ">
                <el-input
                  v-model="addSocialSecurityFrom.security_personal_number"
                  :disabled="addSocialSecurityFrom.is_secuity === 1 ? true : false"
                ></el-input>
              </el-form-item>
              <el-form-item label="社保缴纳基数：" prop="secuity_base">
                <el-input
                  v-model="addSocialSecurityFrom.secuity_base"
                  :disabled="addSocialSecurityFrom.is_secuity === 1 ? true : false"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="是否缴纳公积金："
                prop="is_accum"
                style="width: 100% !important"
              >
                <el-radio-group v-model="addSocialSecurityFrom.is_accum" size="mini">
                  <el-radio :label="2" border>是</el-radio>
                  <el-radio :label="1" border>否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="开始缴纳月份：" prop="accum_starting_month">
                <el-date-picker
                  v-model="addSocialSecurityFrom.accum_starting_month"
                  type="month"
                  placeholder="开始缴纳月份"
                  :disabled="addSocialSecurityFrom.is_accum === 1 ? true : false"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="停止缴存月份：" prop="accum_ting_starting_month">
                <el-date-picker
                  v-model="addSocialSecurityFrom.accum_ting_starting_month"
                  type="month"
                  placeholder="停止缴存月份"
                  :disabled="addSocialSecurityFrom.is_accum === 1 ? true : false"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="公积金补缴月份：" prop="accum_bu_starting_month">
                <el-date-picker
                  v-model="addSocialSecurityFrom.accum_bu_starting_month"
                  type="month"
                  placeholder="公积金补缴月份"
                  :disabled="addSocialSecurityFrom.is_accum === 1 ? true : false"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="公积金个人账号：" prop="accum_account">
                <el-input
                  v-model="addSocialSecurityFrom.accum_account"
                  :disabled="addSocialSecurityFrom.is_accum === 1 ? true : false"
                ></el-input>
              </el-form-item>
              <el-form-item label="缴纳基数" prop="accum_base">
                <el-input
                  v-model="addSocialSecurityFrom.accum_base"
                  :disabled="addSocialSecurityFrom.is_accum === 1 ? true : false"
                ></el-input>
              </el-form-item>
              <el-button
                type="primary"
                @click="submitAddForm('addSocialSecurityFrom')"
                size="mini"
                style="margin: 20px; margin-left: 50%"
                >保 存3</el-button
              >
            </el-form>
          </el-tab-pane>
          <el-tab-pane name="tax_related" label="涉税信息">
            <div class="dplx-item-title item-title">涉税信息</div>
            <el-form
              ref="addTaxRelatedFrom"
              :model="addTaxRelatedFrom"
              label-width="100px"
              size="mini"
            >
              <el-form-item label="开户银行：" prop="bank_account">
                <el-input v-model="addTaxRelatedFrom.bank_account"></el-input>
              </el-form-item>
              <el-form-item label="银行账号：" prop="bank_number">
                <el-input v-model="addTaxRelatedFrom.bank_number"></el-input>
              </el-form-item>
              <el-form-item label="开户行省份：" prop="bank_account_province">
                <el-input v-model="addTaxRelatedFrom.bank_account_province"></el-input>
              </el-form-item>
              <el-form-item label="银行卡状态：" prop="bank_card_status">
                <el-input v-model="addTaxRelatedFrom.bank_card_status"></el-input>
              </el-form-item>
              <el-form-item label="个人投资额：" prop="personal_investment">
                <el-input
                  v-model.number="addTaxRelatedFrom.personal_investment"
                ></el-input>
              </el-form-item>
              <el-form-item label="个人投资比例(%)：" prop="personal_investment_bl">
                <el-input
                  v-model.number="addTaxRelatedFrom.personal_investment_bl"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="特殊情况："
                prop="special"
                style="width: 100% !important"
              >
                <el-radio v-model="addTaxRelatedFrom.special" :label="1">残疾</el-radio>
                <el-radio v-model="addTaxRelatedFrom.special" :label="2">烈属</el-radio>
                <el-radio v-model="addTaxRelatedFrom.special" :label="3">孤老</el-radio>
              </el-form-item>
              <el-form-item label="残疾证号" prop="disability_number">
                <el-input
                  v-model="addTaxRelatedFrom.disability_number"
                  :disabled="addTaxRelatedFrom.special === 1 ? false : true"
                ></el-input>
              </el-form-item>
              <el-form-item label="烈属证号：" prop="is_martyrs_family_number">
                <el-input
                  v-model="addTaxRelatedFrom.is_martyrs_family_number"
                  :disabled="addTaxRelatedFrom.special === 2 ? false : true"
                ></el-input>
              </el-form-item>
              <el-form-item label="电子邮箱：" prop="email">
                <el-input v-model="addTaxRelatedFrom.email"></el-input>
              </el-form-item>
              <el-form-item label="学历：" prop="formal_schooling">
                <el-select
                  v-model="addTaxRelatedFrom.formal_schooling"
                  size="mini"
                  clearable
                >
                  <el-option :value="1" label="研究生"></el-option>
                  <el-option :value="2" label="大学本科"></el-option>
                  <el-option :value="3" label="大学本科以下"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="职务：" prop="position">
                <el-select v-model="addTaxRelatedFrom.position" size="mini" clearable>
                  <el-option :value="1" label="高层"></el-option>
                  <el-option :value="2" label="普通"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="纳税人识别号：" prop="taxpayers_number">
                <el-input v-model="addTaxRelatedFrom.taxpayers_number"></el-input>
              </el-form-item>
              <el-form-item label="备注：" prop="note" style="width: 100% !important">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  v-model="addTaxRelatedFrom.note"
                >
                </el-input>
              </el-form-item>
              <el-form-item label="经常居住地：" prop="address_permanent">
                <el-input v-model="addTaxRelatedFrom.address_permanent"></el-input>
              </el-form-item>
              <el-form-item label="居住街道：" prop="address_street">
                <el-input v-model="addTaxRelatedFrom.address_street"></el-input>
              </el-form-item>
              <el-form-item
                label="居住详细地址："
                prop="address_full"
                style="width: 100% !important"
              >
                <el-input v-model="addTaxRelatedFrom.address_full"></el-input>
              </el-form-item>
              <el-form-item label="户籍所在地：" prop="place_residence">
                <el-input v-model="addTaxRelatedFrom.place_residence"></el-input>
              </el-form-item>
              <el-form-item label="户籍街道：" prop="place_residence_street">
                <el-input v-model="addTaxRelatedFrom.place_residence_street"></el-input>
              </el-form-item>
              <el-form-item
                label="户籍详细地址："
                prop="place_residence_full"
                style="width: 100% !important"
              >
                <el-input v-model="addTaxRelatedFrom.place_residence_full"></el-input>
              </el-form-item>
              <el-form-item label="联系地址：" prop="address_contact">
                <el-input v-model="addTaxRelatedFrom.address_contact"></el-input>
              </el-form-item>
              <el-form-item label="联系街道：" prop="address_contact_street">
                <el-input v-model="addTaxRelatedFrom.address_contact_street"></el-input>
              </el-form-item>
              <el-form-item
                label="联系详细地址："
                prop="address_contact_full"
                style="width: 100% !important"
              >
                <el-input v-model="addTaxRelatedFrom.address_contact_full"></el-input>
              </el-form-item>
              <el-button
                type="primary"
                @click="submitAddForm('addTaxRelatedFrom')"
                size="mini"
                style="margin: 20px; margin-left: 50%"
                >保 存4</el-button
              >
            </el-form>
          </el-tab-pane>
          <el-tab-pane name="contract" label="合同信息">
            <div class="dplx-item-title item-title">合同信息</div>
            <el-form
              ref="addContractFrom"
              :model="addContractFrom"
              label-width="100px"
              size="mini"
            >
              <el-form-item label="合同类型：" prop="contract_type">
                <el-select v-model="addContractFrom.contract_type" size="mini" clearable>
                  <el-option :value="1" label="固定期限劳动合同"></el-option>
                  <el-option :value="2" label="无固定期限劳动合同"></el-option>
                  <el-option :value="3" label="实习协议"></el-option>
                  <el-option :value="4" label="劳务合同"></el-option>
                  <el-option :value="5" label="返聘协议"></el-option>
                  <el-option :value="6" label="劳务派遣合同"></el-option>
                  <el-option :value="7" label="借调合同"></el-option>
                  <el-option :value="0" label="其他"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="合同编号：" prop="contract_number">
                <el-input v-model="addContractFrom.contract_number"></el-input>
              </el-form-item>
              <el-form-item label="合同期限：" prop="contract_term">
                <el-select v-model="addContractFrom.contract_term" size="mini" clearable>
                  <el-option :value="1" label="1年"></el-option>
                  <el-option :value="2" label="2年"></el-option>
                  <el-option :value="3" label="3年"></el-option>
                  <el-option :value="4" label="4年"></el-option>
                  <el-option :value="5" label="5年"></el-option>
                  <el-option :value="6" label="6年"></el-option>
                  <el-option :value="7" label="7年"></el-option>
                  <el-option :value="8" label="8年"></el-option>
                  <el-option :value="9" label="9年"></el-option>
                  <el-option :value="10" label="10年"></el-option>
                  <el-option :value="0" label="永久"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="签订日期" prop="date_signing">
                <el-date-picker
                  v-model="addContractFrom.date_signing"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="签订日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="合同期起" prop="date_signing_start">
                <el-date-picker
                  v-model="addContractFrom.date_signing_start"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="合同期起"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="合同期止" prop="date_signing_end">
                <el-date-picker
                  v-model="addContractFrom.date_signing_end"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="合同期止"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="合同状态：" prop="contract_status">
                <el-select
                  v-model="addContractFrom.contract_status"
                  size="mini"
                  clearable
                >
                  <el-option :value="1" label="执行中"></el-option>
                  <el-option :value="2" label="已到期"></el-option>
                  <el-option :value="3" label="未执行"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="合同备注："
                prop="contract_note"
                style="width: 100% !important"
              >
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  v-model="addContractFrom.contract_note"
                >
                </el-input>
              </el-form-item>
              <el-form-item
                label="合同附件："
                prop="contract_file"
                style="width: 100% !important"
              >
                <el-upload
                  :action="actionHost + '/api/upload/tyc/uploadRelated'"
                  :headers="uploadHeader"
                  multiple
                  :on-success="handleWorkSuccess"
                  :on-preview="handleWorkPreview"
                  :on-remove="handleWorkRemove"
                  :on-change="handleAvatarChange"
                  :file-list="contractFileList"
                  :limit="1"
                  list-type="picture"
                >
                  <el-link type="primary">上传合同凭证</el-link>
                </el-upload>
              </el-form-item>
              <el-button
                type="primary"
                @click="submitAddForm('addContractFrom')"
                size="mini"
                style="margin: 20px; margin-left: 50%"
                >保 存5</el-button
              >
            </el-form>
          </el-tab-pane>
          <el-tab-pane name="family_member" label="家庭成员">
            <div class="dplx-item-title item-title">家庭成员</div>
            <el-table
              border
              :data="addFamilyMemberFrom"
              :row-class-name="rowClassName"
              @selection-change="handleDetailSelectionChange"
              ref="tb"
              style="width: 850px"
            >
              <el-table-column type="selection" width="50" align="center" />
              <el-table-column
                label="序号"
                align="center"
                prop="xh"
                width="50"
              ></el-table-column>
              <el-table-column
                label="关系"
                align="center"
                prop="relationship"
                width="180"
              >
                <template slot-scope="scope">
                  <el-select
                    v-model="addFamilyMemberFrom[scope.row.xh - 1].relationship"
                    placeholder="请选择"
                    size="mini"
                  >
                    <el-option
                      v-for="item in relationshipOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="姓名" align="center" prop="family_name" width="150">
                <template slot-scope="scope">
                  <el-input
                    v-model="addFamilyMemberFrom[scope.row.xh - 1].family_name"
                    size="mini"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                label="证件类型"
                align="center"
                prop="family_id_type"
                width="180"
              >
                <template slot-scope="scope">
                  <el-select
                    v-model="addFamilyMemberFrom[scope.row.xh - 1].family_id_type"
                    placeholder="请选择"
                    size="mini"
                  >
                    <el-option
                      v-for="item in idTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                label="证件号码"
                align="center"
                prop="family_id_number"
                width="180"
              >
                <template slot-scope="scope">
                  <el-input
                    v-model="addFamilyMemberFrom[scope.row.xh - 1].family_id_number"
                    size="mini"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                label="出生日期"
                align="center"
                prop="family_birth"
                width="180"
              >
                <template slot-scope="scope">
                  <el-date-picker
                    v-model="addFamilyMemberFrom[scope.row.xh - 1].family_birth"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="出生日期"
                  ></el-date-picker>
                </template>
              </el-table-column>
              <el-table-column
                label="国籍(地区)"
                align="center"
                prop="family_nationality"
                width="180"
              >
                <template slot-scope="scope">
                  <el-input
                    v-model="addFamilyMemberFrom[scope.row.xh - 1].family_nationality"
                    size="mini"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                label="工作单位"
                align="center"
                prop="family_work_unit"
                width="180"
              >
                <template slot-scope="scope">
                  <el-input
                    v-model="addFamilyMemberFrom[scope.row.xh - 1].family_work_unit"
                    size="mini"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                label="备注"
                align="center"
                prop="family_remarks"
                width="180"
              >
                <template slot-scope="scope">
                  <el-input
                    v-model="addFamilyMemberFrom[scope.row.xh - 1].family_remarks"
                    size="mini"
                  ></el-input>
                </template>
              </el-table-column>
            </el-table>
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="mini"
              @click="addFamilyMemberFun"
              >添加</el-button
            >
            <el-button
              type="success"
              icon="el-icon-delete"
              size="mini"
              @click="handleDeleteDetails"
              >删除</el-button
            >
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="handleDeleteAllDetails"
              >清空</el-button
            >
            <el-button
              type="primary"
              @click="submitAddForm('addFamilyMemberFrom')"
              size="mini"
              style="margin: 20px; margin-left: 50%"
              >保 存6</el-button
            >
          </el-tab-pane>
          <el-tab-pane name="educational_experience" label="教育经历">
            <div class="dplx-item-title item-title">教育经历</div>
            <el-table
              border
              :data="addEducationalFrom"
              :row-class-name="rowClassName7"
              @selection-change="handleDetailSelectionChange7"
              ref="tb7"
              style="width: 850px"
            >
              <el-table-column type="selection" width="50" align="center" />
              <el-table-column
                label="序号"
                align="center"
                prop="xh7"
                width="50"
              ></el-table-column>
              <el-table-column
                label="入学时间"
                align="center"
                prop="admission_time"
                width="180"
              >
                <template slot-scope="scope">
                  <el-date-picker
                    v-model="addEducationalFrom[scope.row.xh7 - 1].admission_time"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="入学时间"
                    size="mini"
                  ></el-date-picker>
                </template>
              </el-table-column>
              <el-table-column
                label="毕业时间"
                align="center"
                prop="graduation_time"
                width="180"
              >
                <template slot-scope="scope">
                  <el-date-picker
                    v-model="addEducationalFrom[scope.row.xh7 - 1].graduation_time"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="毕业时间"
                    size="mini"
                  ></el-date-picker>
                </template>
              </el-table-column>
              <el-table-column label="毕业学校" align="center" prop="school" width="180">
                <template slot-scope="scope">
                  <el-input
                    v-model="addEducationalFrom[scope.row.xh7 - 1].school"
                    size="mini"
                    placeholder="毕业学校"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column label="所学专业" align="center" prop="major" width="180">
                <template slot-scope="scope">
                  <el-input
                    v-model="addEducationalFrom[scope.row.xh7 - 1].major"
                    size="mini"
                    placeholder="所学专业"
                  ></el-input>
                </template>
              </el-table-column>
            </el-table>
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="mini"
              @click="addEducationalFun"
              >添加</el-button
            >
            <el-button
              type="success"
              icon="el-icon-delete"
              size="mini"
              @click="handleDeleteDetails7"
              >删除</el-button
            >
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="handleDeleteAllDetails7"
              >清空</el-button
            >
            <el-button
              type="primary"
              @click="submitAddForm('addEducationalFrom')"
              size="mini"
              style="margin: 20px; margin-left: 50%"
              >保 存7</el-button
            >
          </el-tab-pane>
          <el-tab-pane name="work_experience" label="工作经历">
            <div class="dplx-item-title item-title">工作经历</div>
            <el-table
              border
              :data="addWorkExperienceFrom"
              :row-class-name="rowClassName8"
              @selection-change="handleDetailSelectionChange8"
              ref="tb7"
              style="width: 850px"
            >
              <el-table-column type="selection" width="50" align="center" />
              <el-table-column
                label="序号"
                align="center"
                prop="xh8"
                width="50"
              ></el-table-column>
              <el-table-column
                label="入职日期"
                align="center"
                prop="date_entry"
                width="180"
              >
                <template slot-scope="scope">
                  <el-date-picker
                    v-model="addWorkExperienceFrom[scope.row.xh8 - 1].date_entry"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="入职日期"
                    size="mini"
                  ></el-date-picker>
                </template>
              </el-table-column>
              <el-table-column
                label="离职日期"
                align="center"
                prop="date_departure"
                width="180"
              >
                <template slot-scope="scope">
                  <el-date-picker
                    v-model="addWorkExperienceFrom[scope.row.xh8 - 1].date_departure"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="离职日期"
                    size="mini"
                  ></el-date-picker>
                </template>
              </el-table-column>
              <el-table-column
                label="公司名称"
                align="center"
                prop="company_name"
                width="180"
              >
                <template slot-scope="scope">
                  <el-input
                    v-model="addWorkExperienceFrom[scope.row.xh8 - 1].company_name"
                    size="mini"
                    placeholder="公司名称"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                label="担任职务"
                align="center"
                prop="hold_post"
                width="180"
              >
                <template slot-scope="scope">
                  <el-input
                    v-model="addWorkExperienceFrom[scope.row.xh8 - 1].hold_post"
                    size="mini"
                    placeholder="担任职务"
                  ></el-input>
                </template>
              </el-table-column>
            </el-table>
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="mini"
              @click="addEducationalFun8"
              >添加</el-button
            >
            <el-button
              type="success"
              icon="el-icon-delete"
              size="mini"
              @click="handleDeleteDetails8"
              >删除</el-button
            >
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="handleDeleteAllDetails8"
              >清空</el-button
            >
            <el-button
              type="primary"
              @click="submitAddForm('addWorkExperienceFrom')"
              size="mini"
              style="margin: 20px; margin-left: 50%"
              >保 存8</el-button
            >
          </el-tab-pane>
          <el-tab-pane name="attached_data" label="附件资料">
            <div class="dplx-item-title item-title">附件资料</div>
            <el-table
              border
              :data="addAttachedDataFrom"
              :row-class-name="rowClassName9"
              @selection-change="handleDetailSelectionChange9"
              ref="tb7"
              style="width: 850px"
            >
              <el-table-column type="selection" width="50" align="center" />
              <el-table-column
                label="序号"
                align="center"
                prop="xh9"
                width="50"
              ></el-table-column>
              <el-table-column
                label="材料名称"
                align="center"
                prop="attached_name"
                width="150"
              >
                <template slot-scope="scope">
                  <el-input
                    v-model="addAttachedDataFrom[scope.row.xh9 - 1].attached_name"
                    size="mini"
                    placeholder="材料名称"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column label="附件" align="center" prop="attached">
                <template slot-scope="scope">
                  <el-upload
                    :action="actionHost + '/api/upload/tyc/uploadRelated'"
                    :headers="uploadHeader"
                    multiple
                    :on-success="
                      (res, file) => {
                        handleWorkSuccessAttached(
                          addAttachedDataFrom[scope.row.xh9 - 1].xh9,
                          res,
                          file
                        );
                      }
                    "
                    :on-preview="handleWorkPreview2"
                    :on-remove="
                      (file, fileList) => {
                        handleWorkRemove2(
                          addAttachedDataFrom[scope.row.xh9 - 1].xh9,
                          file,
                          fileList
                        );
                      }
                    "
                    :file-list="attachedFileList[scope.row.xh9 - 1]"
                    :limit="1"
                    list-type="picture"
                  >
                    <el-link type="primary">上传附件资料</el-link>
                  </el-upload>
                </template>
              </el-table-column>
            </el-table>
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="mini"
              @click="addEducationalFun9"
              >添加</el-button
            >
            <el-button
              type="success"
              icon="el-icon-delete"
              size="mini"
              @click="handleDeleteDetails9"
              >删除</el-button
            >
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="handleDeleteAllDetails9"
              >清空</el-button
            >
            <el-button
              type="primary"
              @click="submitAddForm('addAttachedDataFrom')"
              size="mini"
              style="margin: 20px; margin-left: 50%"
              >保 存9</el-button
            >
          </el-tab-pane>
        </el-tabs>
        <!--<el-form-item label="缴纳社保：" prop="is_secuity">-->
        <!--<el-radio-group v-model="addStaffsFrom.is_secuity" size="mini">-->
        <!--<el-radio :label="2" border>是</el-radio>-->
        <!--<el-radio :label="1" border>否</el-radio>-->
        <!--</el-radio-group>-->
        <!--</el-form-item>-->
        <!--<el-form-item-->
        <!--v-if="addStaffsFrom.is_secuity === 2"-->
        <!--label="居住地址"-->
        <!--prop="address"-->
        <!--&gt;-->
        <!--<el-input v-model="addStaffsFrom.address"></el-input>-->
        <!--</el-form-item>-->
        <!--<el-upload-->
        <!--v-if="addStaffsFrom.is_secuity === 2"-->
        <!--class="mb-10"-->
        <!--ref="addFile"-->
        <!--:limit="1"-->
        <!--:action="actionHost + '/api/staff/id_upload/front'"-->
        <!--:headers="uploadHeader"-->
        <!--:on-change="fileChange"-->
        <!--:on-remove="fileRemove"-->
        <!--:on-exceed="fileExceed"-->
        <!--:on-success="fileSuccess"-->
        <!--:file-list="uploadedList"-->
        <!--list-type="picture"-->
        <!--&gt;-->
        <!--<el-link slot="trigger" type="primary">身份证正面11</el-link>-->
        <!--</el-upload>-->
        <!--<el-upload-->
        <!--v-if="addStaffsFrom.is_secuity === 2"-->
        <!--class="mb-10"-->
        <!--ref="addBackFile"-->
        <!--:limit="1"-->
        <!--:action="actionHost + '/api/staff/id_upload/back'"-->
        <!--:headers="uploadHeader"-->
        <!--:on-change="backFileChange"-->
        <!--:on-remove="backFileRemove"-->
        <!--:on-exceed="backFileExceed"-->
        <!--:on-success="backFileSuccess"-->
        <!--:file-list="backUploadedList"-->
        <!--list-type="picture"-->
        <!--&gt;-->
        <!--<el-link slot="trigger" type="primary">身份证背面11</el-link>-->
        <!--</el-upload>-->
        <!--<el-form-item label="缴纳公积金：" prop="is_accum">-->
        <!--<el-radio-group v-model="addStaffsFrom.is_accum" size="mini">-->
        <!--<el-radio :label="2" border>是</el-radio>-->
        <!--<el-radio :label="1" border>否</el-radio>-->
        <!--</el-radio-group>-->
        <!--</el-form-item>-->
        <!--v-if="addStaffsFrom.is_accum === 2"-->
        <!--label="公积金账号："-->
        <!--prop="accum_account"-->
        <!--&gt;-->
        <!--<el-input v-model="addStaffsFrom.accum_account"></el-input>-->
        <!--</el-form-item>-->
        <!--</el-form>-->
      </div>
    </el-drawer>
    <el-drawer
      title="编辑员工"
      :visible.sync="upStaffDrawer"
      direction="rtl"
      :before-close="handleUpStaffBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-form
          ref="upStaffsFrom"
          :rules="upStaffRules"
          :model="upStaffsFrom"
          label-width="100px"
          size="mini"
        >
          <el-form-item label="姓名" prop="staff_name">
            <el-input
              v-model="upStaffsFrom.staff_name"
              @change="handleFieldChange('staff_name', '姓名')"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="staff_phone">
            <el-input
              v-model="upStaffsFrom.staff_phone"
              @change="handleFieldChange('staff_phone', '手机号')"
            ></el-input>
          </el-form-item>
          <el-form-item label="身份证" prop="staff_id_number">
            <el-input
              v-model="upStaffsFrom.staff_id_number"
              @change="handleFieldChange('staff_id_number', '身份证')"
            ></el-input>
          </el-form-item>
          <el-form-item label="入职时间" prop="staff_reg_at">
            <el-date-picker
              v-model="upStaffsFrom.staff_reg_at"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择入职时间"
              @change="handleFieldChange('staff_reg_at', '入职时间')"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="工资" prop="staff_salary">
            <el-input
              v-model.number="upStaffsFrom.staff_salary"
              @change="handleFieldChange('staff_salary', '工资')"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否在职" prop="is_inservice">
            <el-radio-group
              v-model="upStaffsFrom.is_inservice"
              size="mini"
              @change="handleFieldChange('is_inservice', '是否在职')"
            >
              <el-radio :label="1" border>在职</el-radio>
              <el-radio :label="2" border>离职</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="性别" prop="gender">
            <el-select v-model="upStaffsFrom.gender" size="mini" clearable>
              <el-option value="男" label="男">男</el-option>
              <el-option value="女" lable="女">女</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="出生日期" prop="birthday">
            <el-date-picker
              v-model="upStaffsFrom.birthday"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="出生日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="国籍" prop="nationality">
            <el-input v-model="upStaffsFrom.nationality"></el-input>
          </el-form-item>
          <el-form-item label="缴纳社保" prop="is_secuity">
            <el-radio-group
              v-model="upStaffsFrom.is_secuity"
              size="mini"
              @change="handleFieldChange('is_secuity', '缴纳社保')"
            >
              <el-radio :label="2" border>是</el-radio>
              <el-radio :label="1" border>否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="缴纳公积金" prop="is_accum">
            <el-radio-group
              v-model="upStaffsFrom.is_accum"
              size="mini"
              @change="handleFieldChange('is_accum', '缴纳公积金')"
            >
              <el-radio :label="2" border>是</el-radio>
              <el-radio :label="1" border>否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            v-if="upStaffsFrom.is_secuity === 2"
            label="居住地址"
            prop="address"
          >
            <el-input
              v-model="upStaffsFrom.address"
              @change="handleSecuityChange('address', '居住地址')"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="upStaffsFrom.is_secuity === 2"
            label="纳税人识别号"
            prop="taxpayers_number"
          >
            <el-input
              v-model="upStaffsFrom.taxpayers_number"
              @change="handleTaxpayersNumberChange('taxpayers_number', '纳税人识别号')"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="upStaffsFrom.is_secuity === 2"
            label="社保缴纳基数"
            prop="secuity_base"
          >
            <el-input
              v-model="upStaffsFrom.secuity_base"
              @change="handleSecuityChange('secuity_base', '社保缴纳基数')"
            ></el-input>
          </el-form-item>
          <el-upload
            v-if="upStaffsFrom.is_secuity === 2"
            class="mb-10"
            ref="upFile"
            :limit="1"
            :action="actionHost + '/api/staff/id_upload/front'"
            :headers="uploadHeader"
            :on-change="upFileChange"
            :on-remove="upFileRemove"
            :on-exceed="upFileExceed"
            :on-success="upFileSuccess"
            :file-list="upStaffFileList"
            list-type="picture"
          >
            <el-link slot="trigger" type="primary">身份证正面</el-link>
          </el-upload>
          <el-upload
            v-if="upStaffsFrom.is_secuity === 2"
            class="mb-10"
            ref="upBackFile"
            :limit="1"
            :action="actionHost + '/api/staff/id_upload/back'"
            :headers="uploadHeader"
            :on-change="upBackFileChange"
            :on-remove="upBackFileRemove"
            :on-exceed="upBackFileExceed"
            :on-success="upBackFileSuccess"
            :file-list="upBackStaffFileList"
            list-type="picture"
          >
            <el-link slot="trigger" type="primary">身份证背面</el-link>
          </el-upload>
          <el-form-item
            v-if="upStaffsFrom.is_accum === 2"
            label="公积金账号"
            prop="accum_account"
          >
            <el-input
              v-model="upStaffsFrom.accum_account"
              @change="handleAccumChange('accum_account', '公积金账号')"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="upStaffsFrom.is_accum === 2"
            label="缴纳基数"
            prop="accum_base"
          >
            <el-input
              v-model="upStaffsFrom.accum_base"
              @change="handleAccumChange('accum_base', '公积缴纳基数')"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer
      title="财税建议"
      :visible.sync="categoryIndrawer"
      :direction="direction"
      :before-close="handleCloseIn"
      size="50%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -10px">
        <tax-advice :comId="adviceComId" :comName="adviceComName"></tax-advice>
      </div>
    </el-drawer>
    <el-drawer
      title="公司信息"
      :visible.sync="companyInfoDrawer"
      direction="rtl"
      :before-close="handleCompanyInfoBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <company-info :companyId="companyInfoId"></company-info>
        </el-row>
      </div>
    </el-drawer>
  </el-container>
</template>
<script>
import Chat from "common/Chat";
import WxWorkChat from "common/WxWorkChat";
import CallLogs from "common/CallLogs";
import QyGroupChat from "common/QyGroupChat";
import CompanyInfo from "common/CompanyInfo";
import TaxAdvice from "common/TaxAdvice";
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';

export default {
  name: "StaffInfo",
  components: {
    Chat,
    WxWorkChat,
    CallLogs,
    QyGroupChat,
    CompanyInfo,
    TaxAdvice,
  },
  data() {
    return {
      checkedDetail: [],
      checkedDetail7: [],
      checkedDetail8: [],
      checkedDetail9: [],
      relationshipOptions: [
        {
          value: 1,
          label: "本人或户主",
        },
        {
          value: 2,
          label: "配偶",
        },
        {
          value: 3,
          label: "子",
        },
        {
          value: 4,
          label: "女",
        },
        {
          value: 5,
          label: "孙子，孙女，外孙子，外孙女...",
        },
        {
          value: 6,
          label: "父母",
        },
        {
          value: 7,
          label: "祖父母或外祖父母",
        },
        {
          value: 8,
          label: "兄，弟，姐，妹",
        },
        {
          value: 0,
          label: "其他",
        },
      ],
      idTypeOptions: [
        {
          value: 1,
          label: "居民身份证",
        },
        {
          value: 2,
          label: "外国护照",
        },
        {
          value: 3,
          label: "港澳居民来往内地通行证",
        },
        {
          value: 4,
          label: "台湾居民来往大陆通行证",
        },
        {
          value: 5,
          label: "外国人永久居留身份证(外国人永久居留证)",
        },
        {
          value: 6,
          label: "中华人民共和国港澳居民居住证",
        },
        {
          value: 7,
          label: "中华人民共和国台湾居民居住证",
        },
        {
          value: 8,
          label: "中华人民共和国外国人工作许可证(A类)",
        },
        {
          value: 9,
          label: "中华人民共和国外国人工作许可证(B类)",
        },
        {
          value: 10,
          label: "中华人民共和国外国人工作许可证(C类)",
        },
      ],
      tabPosition: "left",
      uploadHeader: { Authorization: localStorage.token },
      infoType: null,
      titleType: null,
      formData: null,
      showStaffPane: "first",
      showTabPane: "first",
      showNewTabPane: "first",
      activeName: 1,
      dateTime: "",
      list_month: "",
      companyName: "",
      tableData: [],
      StaffDetail: [],
      adviceComId: null,
      adviceComName: null,
      batchArr: [],
      allusers: [],
      companies: [],
      staffInfo: [],
      StaffRecords: [],
      infoRecord: [],
      licenseList: [],
      loading: false,
      staffDrawer: false,
      batchDialog: false,
      searchVisible: false,
      serviceDrawer: false,
      uploadingDrawer: false,
      staffRecordDrawer: false,
      categoryIndrawer: false,
      direction: "rtl",
      searchArr: {
        cid: "",
        status: "",
        leader_id: "",
        acc_id: "",
        ass_id: "",
        saler_id: "",
        advisory_id: "",
        invoice_id: "",
        is_bind: "",
        is_subscribe: "",
        archives: "",
      },
      addForm: {
        month: "",
        remark: "",
        type: null,
        cid: null,
        index: null,
      },
      addRules: {
        month: [
          {
            required: true,
            message: "请选择月份",
            trigger: "blur",
          },
        ],
      },
      informForm: {
        cid: null,
        month: "",
      },
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        pageSize: 30, // 每页显示条数
      },
      batch: {
        total: 0,
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示条数
        pageSizes: [10, 50, 100],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      imgPath: "https://www.qiyehuo.com/uploads/adminuser/",
      chatDrawer: false,
      wxChatDrawer: false,
      chatId: "",
      chatName: "",
      wxWorkChatId: "",
      wxchatName: "",
      callLogsDrawer: false,
      company: "",
      callPhone: [],
      callPhone1: [],
      callPhone2: [],
      callPhone3: [],
      qyChatDrawer: false,
      qyChatId: "",
      qyChatName: "",
      addStaffDrawer: false,
      czCompany_id: null,
      insetId: null,
      addStaffsFrom: {
        company_id: null,
        is_inservice: 1,
        staff_name: null,
        work_nnumber: null,
        qt_number_type: null,
        qt_staff_id_number: null,
        staff_phone: null,
        number_type: 1,
        staff_id_number: null,
        native_place: null,
        marital_status: null,
        political_status: null,
        staff_reg_at: null,
        staff_leave_at: null,
        gender: null,
        staff_salary: null,
        nationality: null,
        birthday: null,
        identity_validation: 1,
        type_employment: 1,
        employment_situation: null,
        deduction_expenses: 1,
        id_image_front: [],
        id_image_back: [],
      },
      addStaffRules: {
        staff_name: [{ required: true, message: "请填写姓名", trigger: "blur" }],
        type_employment: [
          { required: true, message: "请选择任职受雇从业类型", trigger: "blur" },
        ],
        staff_phone: [
          { required: true, message: "请填写手机号", trigger: "blur" },
          {
            pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
            message: "手机号格式错误",
            trigger: "blur",
          },
        ],
        staff_salary: [
          { required: true, message: "请填写员工工资", trigger: "blur" },
          {
            pattern: /^(([1-9]\d*)|\d)(\.\d{1,2})?$/,
            message: "非法字符",
            trigger: "blur",
          },
        ],
        staff_reg_at: [{ required: true, message: "请选择入职时间", trigger: "blur" }],
        number_type: [{ required: true, message: "请选择证件类型", trigger: "blur" }],
        staff_id_number: [
          { required: true, message: "请填写证件号码", trigger: "blur" },
          {
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "身份证格式错误",
            trigger: "blur",
          },
        ],
        gender: [{ required: true, message: "请选择性别", trigger: "blur" }],
        birthday: [{ required: true, message: "请填写出生日期", trigger: "blur" }],
        nationality: [{ required: true, message: "请填写国籍", trigger: "blur" }],
        is_inservice: [{ required: true, message: "人员状态不能为空", trigger: "blur" }],
      },
      addInOfficeFrom: {
        type_employee: 6,
        employees_group: null,
        jobs: null,
        nature_work: 1,
        length_service: null,
        trial_status: null,
        probation_period: 2,
        date_conversion: null,
        qq_number: null,
        emergency_person: null,
        emergency_phone: null,
        salary_suspension: null,
        club_discontinuation: null,
        provident_discontinuation: null,
        nature_resignation: null,
        reasons_leaving: null,
      },
      addInOfficeFromRules: {
        nature_work: [{ required: true, message: "请选择工作性质", trigger: "blur" }],
      },
      addSocialSecurityFrom: {
        insurance_scheme: null,
        insured_city: null,
        registered_the: null,
        is_secuity: 1,
        staff_id_type: null,
        staff_id_number: null,
        month_enrollment: null,
        ting_month_enrollment: null,
        bu_month_enrollment: null,
        security_number: null,
        security_personal_number: null,
        secuity_base: null,
        is_accum: 1,
        accum_starting_month: null,
        accum_ting_starting_month: null,
        accum_bu_starting_month: null,
        accum_account: null,
        accum_base: null,
      },
      addFamilyMemberFrom: [],
      addEducationalFrom: [],
      addAttachedDataFrom: [],
      addWorkExperienceFrom: [],
      addFamilyMemberRules: {},
      addTaxRelatedFrom: {
        bank_account: null,
        bank_number: null,
        bank_account_province: null,
        bank_card_status: null,
        personal_investment: null,
        personal_investment_bl: null,
        special: null,
        disability_number: null,
        is_martyrs_family_number: null,
        email: null,
        formal_schooling: null,
        position: null,
        taxpayers_number: null,
        note: null,
        address_permanent: null,
        address_street: null,
        place_residence_full: null,
        address_full: null,
        place_residence: null,
        place_residence_street: null,
        address_contact: null,
        address_contact_street: null,
        address_contact_full: null,
      },
      contractFileList: [],
      attachedFileList: [],
      addContractFrom: {
        contract_type: null,
        contract_number: null,
        contract_term: null,
        date_signing: null,
        date_signing_start: null,
        date_signing_end: null,
        contract_status: null,
        contract_note: null,
        contract_file: null,
      },
      uploadedList: [],
      backUploadedList: [],
      upStaffDrawer: false,
      upStaffsFrom: {
        id: null,
        company_id: null,
        staff_name: null,
        staff_phone: null,
        staff_salary: null,
        staff_reg_at: null,
        staff_id_number: null,
        gender: null,
        birthday: null,
        nationality: null,
        is_secuity: 1,
        is_accum: 1,
        is_inservice: 1,
        address: null,
        taxpayers_number: null,
        secuity_base: null,
        accum_account: null,
        accum_base: null,
        id_image_front: [],
        id_image_back: [],
      },
      upStaffRules: {
        staff_name: [{ required: true, message: "请填写姓名", trigger: "blur" }],
        staff_phone: [
          { required: true, message: "请填写手机号", trigger: "blur" },
          {
            pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
            message: "手机号格式错误",
            trigger: "blur",
          },
        ],
        staff_salary: [
          { required: true, message: "请填写员工工资", trigger: "blur" },
          {
            pattern: /^(([1-9]\d*)|\d)(\.\d{1,2})?$/,
            message: "非法字符",
            trigger: "blur",
          },
        ],
        staff_reg_at: [{ required: true, message: "请选择入职时间", trigger: "blur" }],
        staff_id_number: [
          { required: true, message: "请填证件号码", trigger: "blur" },
          {
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "身份证格式错误",
            trigger: "blur",
          },
        ],
      },
      upStaffFileList: [],
      upBackStaffFileList: [],
      detail: [],
      staffCount: {
        total: 0,
        is_work: 0,
        not_work: 0,
      },
      companyInfoDrawer: false,
      companyInfoId: null,
      addtionData: { value: "无", label: "NULL" },
    };
  },
  computed: {
    actionHost: {
      get: function () {
        return process.env.NODE_ENV === "development" ? "" : "https://weixin.qiyehuo.com";
      },
    },
    pageData: function () {
      return this.staffInfo;
    },
    searchStr: function () {
      let str = "";
      for (let key in this.searchArr) {
        str += "&" + key + "=" + this.searchArr[key];
      }

      return str;
    },
    collapse() {
      return this.$store.state.collapse;
    },
    allusersOptions() {
      return [...this.allusers, this.addtionData];
    }
  },
  methods: {
    // 跳转到传递参数页
    searchAccess(cid) {
      this.$router.push({
        path: "/staff_msgs",
        query: {
          company_id: cid,
        },
      });
    },
    filterOptions(node, keyword) {
  return filterKeywordOptions(node, keyword);
},
    rowClassName({ row, rowIndex }) {
      row.xh = rowIndex + 1;
    },
    handleDetailSelectionChange(selection) {
      // if (selection.length > 1) {
      //   this.$refs.tb.clearSelection()
      //   this.$refs.tb.toggleRowSelection(selection.pop())
      // } else {
      this.checkedDetail = selection;
      // }
    },
    handleDeleteDetails() {
      if (this.checkedDetail.length === 0) {
        this.$alert("请先选择要删除的数据", "提示", { confirmButtonText: "确定" });
      } else {
        console.log(this.checkedDetail);
        for (var i = 0; i < this.checkedDetail.length; i++) {
          console.log(i);
          this.addFamilyMemberFrom.splice(this.checkedDetail[i], 1);
        }
      }
    },
    handleDeleteAllDetails() {
      this.addFamilyMemberFrom = [];
    },
    addFamilyMemberFun() {
      let obj = {};
      obj.relationship = null;
      obj.family_name = null;
      obj.family_id_type = 1;
      obj.family_id_number = null;
      obj.family_birth = null;
      obj.family_nationality = null;
      obj.family_work_unit = null;
      obj.family_remarks = null;
      this.addFamilyMemberFrom.push(obj);
    },
    addEducationalFun() {
      let obj = {};
      obj.admission_time = null;
      obj.graduation_time = null;
      obj.school = null;
      obj.major = null;
      this.addEducationalFrom.push(obj);
    },
    rowClassName7({ row, rowIndex }) {
      row.xh7 = rowIndex + 1;
    },
    handleDetailSelectionChange7(selection) {
      // if (selection.length > 1) {
      //   this.$refs.tb7.clearSelection()
      //   this.$refs.tb7.toggleRowSelection(selection.pop())
      // } else {
      this.checkedDetail7 = selection;
      // }
    },
    handleDeleteDetails7() {
      if (this.checkedDetail7.length === 0) {
        this.$alert("请先选择要删除的数据", "提示", { confirmButtonText: "确定" });
      } else {
        for (var i = 0; i < this.checkedDetail7.length; i++) {
          this.addEducationalFrom.splice(this.checkedDetail7[i], 1);
        }
        // this.addEducationalFrom.splice(this.checkedDetail7[0].xh7 - 1, 1)
      }
    },
    handleDeleteAllDetails7() {
      this.addEducationalFrom = [];
    },
    addEducationalFun8() {
      let obj = {};
      obj.date_entry = null;
      obj.date_departure = null;
      obj.company_name = null;
      obj.hold_post = null;
      this.addWorkExperienceFrom.push(obj);
    },
    rowClassName8({ row, rowIndex }) {
      row.xh8 = rowIndex + 1;
    },
    handleDetailSelectionChange8(selection) {
      // if (selection.length > 1) {
      //   this.$refs.tb7.clearSelection()
      //   this.$refs.tb7.toggleRowSelection(selection.pop())
      // } else {
      this.checkedDetail8 = selection;
      // }
    },
    handleDeleteDetails8() {
      if (this.checkedDetail8.length === 0) {
        this.$alert("请先选择要删除的数据", "提示", { confirmButtonText: "确定" });
      } else {
        for (var i = 0; i < this.checkedDetail8.length; i++) {
          this.addWorkExperienceFrom.splice(this.checkedDetail8[i], 1);
        }
        // this.addWorkExperienceFrom.splice(this.checkedDetail8[0].xh8 - 1, 1)
      }
    },
    handleDeleteAllDetails8() {
      this.addWorkExperienceFrom = [];
    },
    addEducationalFun9() {
      let obj = {};
      obj.attached_name = null;
      this.addAttachedDataFrom.push(obj);
    },
    rowClassName9({ row, rowIndex }) {
      row.xh9 = rowIndex + 1;
    },
    handleDetailSelectionChange9(selection) {
      // if (selection.length > 1) {
      //   this.$refs.tb7.clearSelection()
      //   this.$refs.tb7.toggleRowSelection(selection.pop())
      // } else {
      this.checkedDetail9 = selection;
      // }
    },
    handleDeleteDetails9() {
      if (this.checkedDetail9.length === 0) {
        this.$alert("请先选择要删除的数据", "提示", { confirmButtonText: "确定" });
      } else {
        for (var i = 0; i < this.checkedDetail9.length; i++) {
          this.addAttachedDataFrom.splice(this.checkedDetail9[i], 1);
        }
        // this.addAttachedDataFrom.splice(this.checkedDetail8[0].xh9 - 1, 1)
      }
    },
    handleDeleteAllDetails9() {
      this.addAttachedDataFrom = [];
    },
    handleWorkSuccessAttached(xh9, res, file) {
      var arr = [];
      if (res.code === 0) {
        arr.push({
          url: res.data.signedUrl,
          buphoto: res.data.buphoto,
          name: file.name,
          uid: file.uid,
        });
        this.attachedFileList[xh9 - 1] = arr;
        if (this.addAttachedDataFrom[xh9 - 1].attached_name === null) {
          this.addAttachedDataFrom[xh9 - 1].attached_name = file.name;
        }
      } else {
        this.$message.error(res.msg);
      }
    },
    handleWorkRemove2(xh9, file, fileList) {
      this.attachedFileList[xh9 - 1] = fileList;
      if (this.addAttachedDataFrom[xh9 - 1].attached_name === file.name) {
        this.addAttachedDataFrom[xh9 - 1].attached_name = null;
      }
    },
    handleWorkPreview2(file) {
      var tempwindow = window.open("_blank");
      tempwindow.location = file.url;
    },
    handleWorkSuccess(res, file) {
      if (res.code === 0) {
        this.contractFileList.push({
          url: res.data.signedUrl,
          name: file.name,
          uid: file.uid,
        });
      } else {
        this.$message.error(res.msg);
      }
    },
    handleAvatarChange(res, file) {
      this.contractFileList = file;
    },
    handleWorkRemove(file, fileList) {
      this.contractFileList = fileList;
    },
    handleWorkPreview(file) {
      var tempwindow = window.open("_blank");
      tempwindow.location = file.url;
    },
    // 复制功能
    copy(data) {
      // 存储传递过来的数据
      let OrderNumber = data;
      // 创建一个input 元素
      // createElement() 方法通过指定名称创建一个元素
      let newInput = document.createElement("input");
      // 讲存储的数据赋值给input的value值
      newInput.value = OrderNumber;
      // appendChild() 方法向节点添加最后一个子节点。
      document.body.appendChild(newInput);
      // 选中input元素中的文本
      // select() 方法用于选择该元素中的文本。
      newInput.select();
      // 执行浏览器复制命令
      //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
      document.execCommand("Copy");
      // 清空输入框
      newInput.remove();
      // 下面是element的弹窗 不需要的自行删除就好
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    copySome(data) {
      this.copy(data);
    },
    getPageData() {
      this.$axios
        .get(
          "/api/staff_info?page=" +
            this.pageOption.currentPage +
            "&limit=" +
            this.pageOption.pageSize +
            this.searchStr
        )
        .then((res) => {
          const { data } = res;
          this.staffInfo = data.data.list.data;
          console.log("=====this.staffInfo=====", this.staffInfo);
          this.allusers = data.data.users;
          this.list_month = data.data.month;
          this.pageOption.total = data.data.list.total;
          this.pageOption.currentPage = data.data.list.current_page;
          this.batchArr = [];
          for (let key in this.staffInfo) {
            this.batchArr.push(this.staffInfo[key].id);
          }
        });
    },
    handleInform(row, index) {
      this.informForm.cid = row.id;
      this.informForm.month = this.list_month;
      this.$axios.post("/api/staff_info/info", this.informForm).then((res) => {
        let { data } = res;
        if (data.code === 0) {
          this.$message.success(data.msg);
          if (data.data.state && !Array.isArray(data.data.state)) {
            this.staffInfo[index].staff_state.unshift(data.data.state);
          }
          this.staffInfo[index].staff_info.unshift(data.data.record);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleInformAdd(row, index) {
      this.informForm.cid = row.id;
      this.informForm.month = this.list_month;
      this.$axios.post("/api/staff_info/info_add", this.informForm).then((res) => {
        let { data } = res;
        if (data.code === 0) {
          this.$message.success(data.msg);
          this.staffInfo[index].staff_add.unshift(data.data.record);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.getPageData();
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
      this.getPageData();
    },
    getYearMonth() {
      let now = new Date();
      let year = now.getFullYear();
      let month = now.getMonth() + 1;
      month = month - 1;
      if (month < 10) {
        month = "0" + month;
      }
      return year + "-" + month;
    },
    handleDateTimeChange(val) {
      this.pageOption.currentPage = 1;
      this.getPageData();
    },
    handleCompanyChange(val) {
      this.pageOption.currentPage = 1;
      this.getPageData();
    },
    remoteCompanyMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.searchCompanys(query);
        }, 200);
      } else {
        this.companies = [];
      }
    },
    searchCompanys(query) {
      this.$axios.get("/api/admin/searchCompany?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.companies = data.data.companies;
        }
      });
    },
    handleUploadImg(row, index, type) {
      this.row = row;
      this.addForm.index = index;
      this.addForm.cid = row.id;
      this.addForm.type = type;
      this.addForm.month = this.list_month;
      this.formData = new FormData();
      this.uploadingDrawer = true;
    },
    handleAddClose(done) {
      this.$refs["addForm"].resetFields();
      this.licenseList = [];
      done();
      this.formData = null;
    },
    pickerDataChangeUpload(val) {
      if (val) {
        this.addForm.month = val;
      } else {
        this.addForm.month = "";
      }
    },
    handleLicensePreview(file) {},
    handleLicenseChange(file, fileList) {
      this.licenseList = fileList;
    },
    handleLicenseRemove(file, fileList) {
      this.licenseList = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseList.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.addForm) {
        this.formData.append(key, this.addForm[key]);
      }
    },
    handleParse(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseList.length < 5) {
            that.licenseList.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    submitAddUpload(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.licenseList.length === 0) {
            this.$message.error("请上传申报图片");
            return;
          }
          this.licenseList.forEach((file) => this.formData.append("file[]", file.raw));
          for (let key in this.addForm) {
            this.formData.append(key, this.addForm[key]);
          }
          this.$axios.post("/api/staff_info/upload", this.formData).then((res) => {
            let { data } = res;
            if (data.code === 0) {
              this.$message.success(data.msg);
              if (this.addForm.type === 5) {
                this.staffInfo[this.addForm.index].staff_secuity.unshift(
                  data.data.record
                );
              }
              if (this.addForm.type === 6) {
                this.staffInfo[this.addForm.index].staff_accum.unshift(data.data.record);
              }
              this.uploadingDrawer = false;
              this.$refs["addForm"].resetFields();
              this.licenseList = [];
              this.licenseList = [];
            } else {
              this.$message.error(data.msg);
            }
          });
        }
      });
    },
    handleOpen(cid, cname, index) {
      this.getRecordDatas(cid);
      this.getStaffMsg(cid);
      this.addStaffsFrom.company_id = cid;
      this.companyName = cname;
      this.serviceDrawer = true;
      this.czCompany_id = cid;
    },
    handleOpenAdvice(cid, cname, index) {
      this.adviceComId = cid;
      this.adviceComName = cname;
      this.categoryIndrawer = true;
    },
    getRecordDatas(cid) {
      this.$axios.get("/api/staff_info/records/" + cid).then((res) => {
        let { data } = res;
        if (data.code === 0) {
          this.infoRecord = data.data.records;
        }
      });
    },
    handleSearchGetData() {
      this.searchVisible = false;
      this.getPageData();
    },
    handleClearSearchGetData() {
      this.searchArr.leader_id = "";
      this.searchArr.acc_id = "";
      this.searchArr.ass_id = "";
      this.searchArr.saler_id = "";
      this.searchArr.advisory_id = "";
      this.searchArr.invoice_id = "";
      this.searchArr.is_bind = "";
      this.searchArr.is_subscribe = "";
      this.searchVisible = false;
      this.getPageData();
      this.searchArr.archives = "";
    },
    handleSureChange(rid) {
      this.$axios.post("/api/staff_info/is_sure/" + rid).then((res) => {
        let { data } = res;
        if (data.code === 0) {
          for (let key in this.infoRecord) {
            for (let key2 in this.infoRecord[key].record) {
              if (this.infoRecord[key].record[key2].id === rid) {
                this.infoRecord[key].record[key2].is_sure = 2;
              }
              if (data.data.record) {
                this.infoRecord[key].record.unshift(data.data.record);
              }
              continue;
            }
          }
        }
      });
    },
    handleBatchStaffInfo(types) {
      this.batchDialog = true;
      this.infoType = types;
    },
    batchSendInform() {
      if (!this.dateTime) {
        this.$message.error("请选择月份");
        return;
      }
      this.$axios
        .post("/api/staff_info/batch_inform", {
          dateTime: this.dateTime,
          batchArr: this.batchArr,
          type: this.infoType,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 1002) {
            this.$message.error(data.msg);
          }
          this.$message.success(data.msg);
          this.getPageData();
        });
      this.batchDialog = false;
    },
    getStaffMsg(cid) {
      this.$axios.get("/api/staff_msg/list?company_id=" + cid).then((res) => {
        const { data } = res;
        this.tableData = data.data.list;
        this.staffCount.total = data.data.list.length;
        this.getStaffCount();
      });
    },
    getStaffCount() {
      for (var i = 0; i < this.tableData.length; i++) {
        this.tableData[i].is_inservice === 1
          ? this.staffCount.is_work++
          : this.staffCount.not_work++;
      }
    },
    handleOpenStaffDetail(row) {
      this.StaffDetail = [];
      this.$axios.get("/api/staff_msg/detail/" + row.id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.StaffDetail = data.data.detail;
        }
      });
      this.staffDrawer = true;
      this.handleOpenStaffRecord(row);
    },
    handleOpenStaffRecord(row) {
      this.StaffRecords = [];
      this.$axios
        .get("/api/staff_msg/records/" + row.company_id + "/" + row.id)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.StaffRecords = data.data.records;
          }
        });
      this.staffRecordDrawer = true;
    },
    handleChatOpen(chat, companyName) {
      if (chat) {
        this.chatDrawer = true;
        setTimeout(() => {
          this.chatId = chat.chat_id;
          this.chatName = companyName;
        });
      }
    },
    handleWxChatOpen(chat, companyName) {
      if (chat) {
        this.wxChatDrawer = true;
        setTimeout(() => {
          this.wxWorkChatId = chat.chat_id;
          this.wxchatName = companyName;
        });
      }
    },
    handleChatBeforeClose(done) {
      this.chatId = "";
      this.chatName = "";
      done();
    },
    handleWxChatBeforeClose(done) {
      this.wxWorkChatId = "";
      this.wxchatName = "";
      done();
    },
    handCallLogsOpen(row) {
      this.callLogsDrawer = true;
      setTimeout(() => {
        this.company = row.company_name;
        if (row.user) this.callPhone.push(row.user.phone);
        if (row.docking_phone) this.callPhone3.push(row.docking_phone);
        if (row.orders.length > 0) {
          for (var i = 0; i < row.orders.length; i++) {
            if (
              row.orders[i].customer_phone &&
              this.callPhone1.indexOf(row.orders[i].customer_phone) === -1
            ) {
              this.callPhone1.push(row.orders[i].customer_phone);
            }
            if (
              row.orders[i].corporate_phone &&
              this.callPhone2.indexOf(row.orders[i].corporate_phone) === -1
            ) {
              this.callPhone2.push(row.orders[i].corporate_phone);
            }
          }
        }
      });
    },
    handleCallLogsBeforeClose(done) {
      this.company = "";
      this.callPhone = [];
      this.callPhone1 = [];
      this.callPhone2 = [];
      this.callPhone3 = [];
      done();
    },
    handleQyChatOpen(chat, chatName) {
      if (chat) {
        this.qyChatDrawer = true;
        setTimeout(() => {
          this.qyChatId = chat.chat_id;
          this.qyChatName = chatName;
        });
      }
    },
    handleQyChatBeforeClose(done) {
      this.qyChatId = "";
      this.qyChatName = "";
      done();
    },
    handleAddStaffOpen() {
      this.addStaffDrawer = true;
    },
    handlebatchStaff(companyId, companyName) {
      this.$axios
        .post("api/staff/newbatchstore?page=" + this.batch.currentPage, {
          params: {
            perpage: this.batch.pageSize,
            companyName: companyName,
            companyId: companyId,
          },
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.getStaffMsg(companyId);
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        })
        .catch();
    },
    handleAddStaffBeforeClose(done) {
      this.cleaerAddStaffFrom();
      done();
    },
    cleaerAddStaffFrom() {
      // this.addStaffsFrom.company_id = null
      this.addStaffsFrom.staff_name = null;
      this.addStaffsFrom.staff_phone = null;
      this.addStaffsFrom.staff_salary = null;
      this.addStaffsFrom.staff_reg_at = null;
      this.addStaffsFrom.staff_id_number = null;
      this.addStaffsFrom.is_secuity = 1;
      this.addStaffsFrom.is_accum = 1;
      this.addStaffsFrom.is_inservice = 1;
      this.addStaffsFrom.address = null;
      this.addStaffsFrom.secuity_base = null;
      this.addStaffsFrom.accum_account = null;
      this.addStaffsFrom.accum_base = null;
      this.addStaffsFrom.id_image_front = [];
      this.addStaffsFrom.id_image_back = [];
      this.uploadedList = [];
      this.backUploadedList = [];
    },
    submitAddStaff() {
      // if (this.addStaffsFrom.is_secuity === 2) {
      //   if (!this.addStaffsFrom.address) {
      //     this.$message.error('居住地址不能为空')
      //     return
      //   }
      //   if (!this.addStaffsFrom.taxpayers_number) {
      //     this.$message.error('纳税人识别号不能为空')
      //     return
      //   }
      //   if (!this.addStaffsFrom.secuity_base) {
      //     this.$message.error('社保基数不能为空')
      //     return
      //   }
      //
      //   if (this.addStaffsFrom.id_image_front.length === 0) {
      //     this.$message.error('请上传身份证正面照片')
      //     return
      //   }
      //
      //   if (this.addStaffsFrom.id_image_back.length === 0) {
      //     this.$message.error('请上传身份证反面照片')
      //     return
      //   }
      // }
      //
      // if (this.addStaffsFrom.is_accum === 2) {
      //   if (!this.addStaffsFrom.accum_account) {
      //     this.$message.error('公积金账号不能为空')
      //     return
      //   }
      // }
      //
      // if (this.addStaffsFrom.is_accum === 2) {
      //   if (!this.addStaffsFrom.accum_base) {
      //     this.$message.error('公积金缴纳基数不能为空')
      //     return
      //   }
      // }
      this.$refs["addStaffsFrom"].validate((valid) => {
        if (valid) {
          this.$axios.post("/api/staff/store", this.addStaffsFrom).then((res) => {
            let { data } = res;
            if (data.code === 0) {
              this.getStaffMsg(this.addStaffsFrom.company_id);
              // this.addStaffDrawer = false
              this.insetId = data.data.insetId;
              alert(this.insetId);
              this.cleaerAddStaffFrom();
              this.$message.success(data.msg);
            } else {
              this.$message.error(data.msg);
            }
          });
        }
      });
    },
    submitAddForm(form) {
      if (this.insetId === null) {
        this.$message.error("请先保存基本信息");
        return;
      }
      if (this.czCompany_id === null) {
        this.$message.error("公司ID不能为空");
        return;
      }
      if (
        form === "addFamilyMemberFrom" ||
        form === "addEducationalFrom" ||
        form === "addWorkExperienceFrom" ||
        form === "addAttachedDataFrom"
      ) {
        this.$axios
          .post("api/staff/addfrom", {
            params: {
              company_id: this.czCompany_id,
              insetId: this.insetId,
              addFrom: this[form],
              value: form,
              file: this.attachedFileList,
            },
          })
          .then(({ data }) => {
            if (data.code === 0) {
              this.insetId = data.data.insetId;
              this.$message.success(data.msg);
            } else {
              this.$message.error(data.msg);
            }
          })
          .catch();
      } else {
        this.$refs[form].validate((valid) => {
          if (valid) {
            this.$axios
              .post("api/staff/addfrom", {
                params: {
                  company_id: this.czCompany_id,
                  insetId: this.insetId,
                  addFrom: this[form],
                  value: form,
                  file: this.contractFileList,
                },
              })
              .then(({ data }) => {
                if (data.code === 0) {
                  this.insetId = data.data.insetId;
                  this.$message.success(data.msg);
                } else {
                  this.$message.error(data.msg);
                }
              })
              .catch();
          }
        });
      }
      console.log("===this.addFamilyMemberFrom===", this.addFamilyMemberFrom);
    },
    fileChange(file, fileList) {
      this.uploadedList = fileList;
    },
    fileRemove(file, fileList) {
      this.uploadedList = fileList;
    },
    fileExceed(files, fileList) {
      this.$message.error("只能上传一张图片，如需修改请删除已上传的图片后重新上传");
    },
    fileSuccess(res, file, fileLis) {
      if (res.code === 0) {
        if (this.addStaffsFrom.staff_name !== res.data.result.result.name) {
          this.$message.warning("当前输入的姓名与身份证不符，请注意检查");
        } else if (this.addStaffsFrom.staff_id_number !== res.data.result.result.code) {
          this.$message.warning("当前输入的身份证号码与身份证不符，请注意检查");
        } else {
          this.$message.success(res.msg);
        }
        this.addStaffsFrom.id_image_front = res.data;
      } else {
        this.$refs["addFile"].clearFiles();
        this.$message.error(res.msg);
      }
    },
    backFileChange(file, fileList) {
      this.backUploadedList = fileList;
    },
    backFileRemove(file, fileList) {
      this.backUploadedList = fileList;
    },
    backFileExceed(files, fileList) {
      this.$message.error("只能上传一张图片，如需修改请删除已上传的图片后重新上传");
    },
    backFileSuccess(res, file, fileLis) {
      if (res.code === 0) {
        this.addStaffsFrom.id_image_back = res.data;
        this.$message.success(res.msg);
      } else {
        this.$refs["addBackFile"].clearFiles();
        this.$message.error(res.msg);
      }
    },
    handleStaffUpdateOpen(row, index) {
      this.$axios.get("/api/staff_msg/detail/" + row.id).then((res) => {
        let { data } = res;
        if (data.code === 0) {
          this.detail = data.data.detail;
          this.upStaffsFrom.id = row.id;
          this.upStaffsFrom.company_id = data.data.detail.company_id;
          this.upStaffsFrom.staff_name = data.data.detail.staff_name;
          this.upStaffsFrom.staff_phone = data.data.detail.staff_phone;
          this.upStaffsFrom.staff_salary = data.data.detail.staff_salary;
          this.upStaffsFrom.staff_reg_at = data.data.detail.staff_reg_at;
          this.upStaffsFrom.staff_id_number = data.data.detail.staff_id_number;
          this.upStaffsFrom.gender = data.data.detail.gender;
          this.upStaffsFrom.birthday = data.data.detail.birthday;
          this.upStaffsFrom.nationality = data.data.detail.nationality;
          this.upStaffsFrom.is_secuity = data.data.detail.is_secuity;
          this.upStaffsFrom.is_accum = data.data.detail.is_accum;
          this.upStaffsFrom.is_inservice = data.data.detail.is_inservice;
          if (data.data.detail.secuity) {
            this.upStaffsFrom.address = data.data.detail.secuity.address;
            this.upStaffsFrom.secuity_base = data.data.detail.secuity.secuity_base;
            this.upStaffsFrom.taxpayers_number =
              data.data.detail.secuity.taxpayers_number;
          }

          if (data.data.detail.accum) {
            this.upStaffsFrom.accum_account = data.data.detail.accum.accum_account;
            this.upStaffsFrom.accum_base = data.data.detail.accum.accum_base;
          }

          if (data.data.detail.src_list.length === 1) {
            let idFace = data.data.detail.idcard[0].id_face;

            if (idFace === 1) {
              let path1 = data.data.detail.src_list[0];
              let index1 = path1.lastIndexOf(".");
              let ext = path1.substr(index1 + 1);
              this.upStaffFileList.push({ name: "front." + ext, url: path1 });
            } else {
              let path2 = data.data.detail.src_list[0];
              let index2 = path2.lastIndexOf(".");
              let ext2 = path2.substr(index2 + 1);
              this.upBackStaffFileList.push({
                name: "back." + ext2,
                url: path2,
              });
            }
          }

          if (data.data.detail.src_list.length === 2) {
            let path1 = data.data.detail.src_list[0];
            let index1 = path1.lastIndexOf(".");
            let ext = path1.substr(index1 + 1);
            this.upStaffFileList.push({ name: "front." + ext, url: path1 });
            let path2 = data.data.detail.src_list[1];
            let index2 = path2.lastIndexOf(".");
            let ext2 = path2.substr(index2 + 1);
            this.upBackStaffFileList.push({ name: "back." + ext2, url: path2 });
          }
          // id_image_front: [],
          // id_image_back: []
          this.upStaffDrawer = true;
        }
      });
    },
    upFileChange(file, fileList) {
      this.upStaffFileList = fileList;
    },
    upFileRemove(file, fileList) {
      this.upStaffFileList = fileList;
    },
    upFileExceed(files, fileList) {
      this.$message.error("只能上传一张图片，如需修改请删除已上传的图片后重新上传");
    },
    upFileSuccess(res, file, fileLis) {
      if (res.code === 0) {
        this.idCardChange(res.data, 1);
      } else {
        this.$refs["upFile"].clearFiles();
        this.$message.error(res.msg);
      }
    },
    idCardChange(card, type) {
      this.$axios
        .put("/api/staff/upStaff/idcard/" + this.upStaffsFrom.id, {
          card,
          type,
        })
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.getRecordDatas(this.upStaffsFrom.company_id);
            this.$message.success(data.msg);
          }
        });
    },
    upBackFileChange(file, fileList) {
      this.upBackStaffFileList = fileList;
    },
    upBackFileRemove(file, fileList) {
      this.upBackStaffFileList = fileList;
    },
    upBackFileExceed(files, fileList) {
      this.$message.error("只能上传一张图片，如需修改请删除已上传的图片后重新上传");
    },
    upBackFileSuccess(res, file, fileLis) {
      if (res.code === 0) {
        this.idCardChange(res.data, 2);
      } else {
        this.$refs["upBackFile"].clearFiles();
        this.$message.error(res.msg);
      }
    },
    handleFieldChange(field, fieldName) {
      if (!this.upStaffsFrom[field]) return;
      let check = true;
      let oldValue = this.detail[field];
      let newValue = this.upStaffsFrom[field];
      // if (oldValue === newValue) return
      if (field === "staff_phone") {
        check = /^1(3|4|5|6|7|8|9)\d{9}$/.test(newValue);
      }
      if (field === "staff_id_number") {
        check = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(newValue);
      }
      if (field === "staff_salary") {
        check = /^(([1-9]\d*)|\d)(\.\d{1,2})?$/.test(newValue);
      }
      if (!check) return;
      this.submitFieldChange(field, oldValue, newValue, fieldName);
    },
    submitFieldChange(field, oldValue, newValue, fieldName) {
      this.$axios
        .put("/api/staff/upStaff/" + this.upStaffsFrom.id, {
          field: field,
          oldValue: oldValue,
          newValue: newValue,
          fieldName: fieldName,
        })
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.getRecordDatas(this.upStaffsFrom.company_id);
            this.getStaffMsg(this.upStaffsFrom.company_id);
            this.$message.success(data.msg);
          }
        });
    },
    handleIsSecuityChange(val) {
      if (val === 2) return;
      this.$confirm(
        "确认将缴纳社保改为否吗？此操作将会删除已有地址、缴纳基数、身份证等信息",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          let oldValue = this.detail.is_secuity;
          let newValue = this.upStaffsFrom.is_secuity;
          this.submitFieldChange("is_secuity", oldValue, newValue, "缴纳社保");
        })
        .catch(() => {
          this.upStaffsFrom.is_secuity = this.detail.is_secuity;
        });
    },
    handleTaxpayersNumberChange(field, fieldName) {
      if (!this.upStaffsFrom[field]) return;
      console.log("==detail==", this.detail);
      let oldValue = this.detail.taxpayers_number ? this.detail.secuity[field] : null;
      let newValue = this.upStaffsFrom[field];
      if (oldValue === newValue) return;
      this.$axios
        .put("/api/staff/upStaff/secuity/" + this.upStaffsFrom.id, {
          field,
          oldValue,
          newValue,
          fieldName,
        })
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.getRecordDatas(this.upStaffsFrom.company_id);
            this.$message.success(data.msg);
          }
        });
    },
    handleSecuityChange(field, fieldName) {
      if (!this.upStaffsFrom[field]) return;
      let oldValue = this.detail.secuity ? this.detail.secuity[field] : null;
      let newValue = this.upStaffsFrom[field];
      if (oldValue === newValue) return;
      this.$axios
        .put("/api/staff/upStaff/secuity/" + this.upStaffsFrom.id, {
          field,
          oldValue,
          newValue,
          fieldName,
        })
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.getRecordDatas(this.upStaffsFrom.company_id);
            this.$message.success(data.msg);
          }
        });
    },
    handleAccumChange(field, fieldName) {
      if (!this.upStaffsFrom[field]) return;
      let oldValue = this.accum ? this.accum[field] : null;
      let newValue = this.upStaffsFrom[field];
      if (oldValue === newValue) return;
      this.$axios
        .put("/api/staff/upStaff/accum/" + this.upStaffsFrom.id, {
          field,
          oldValue,
          newValue,
          fieldName,
        })
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.getRecordDatas(this.upStaffsFrom.company_id);
            this.$message.success(data.msg);
          }
        });
    },
    cleaerUpStaffFrom() {
      this.upStaffsFrom.id = null;
      this.upStaffsFrom.company_id = null;
      this.upStaffsFrom.staff_name = null;
      this.upStaffsFrom.staff_phone = null;
      this.upStaffsFrom.staff_salary = null;
      this.upStaffsFrom.staff_reg_at = null;
      this.upStaffsFrom.staff_id_number = null;
      this.upStaffsFrom.is_secuity = 1;
      this.upStaffsFrom.is_accum = 1;
      this.upStaffsFrom.is_inservice = 1;
      this.upStaffsFrom.address = null;
      this.upStaffsFrom.secuity_base = null;
      this.upStaffsFrom.accum_account = null;
      this.upStaffsFrom.accum_base = null;
      this.upStaffsFrom.id_image_front = [];
      this.upStaffsFrom.id_image_back = [];
      this.upStaffFileList = [];
      this.upBackStaffFileList = [];
      this.detail = null;
    },
    handleUpStaffBeforeClose(done) {
      this.cleaerUpStaffFrom();
      done();
    },
    handleServiceBeforeClose(done) {
      this.staffCount.total = 0;
      this.staffCount.is_work = 0;
      this.staffCount.not_work = 0;
      done();
    },
    handleCloseIn(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          setTimeout(() => {
            this.adviceComId = null;
            // this.$refs.categoryForm.resetFields()
            // this.$refs.uploadMutiple.clearFiles()
            this.needUrl = [];
          });
          done();
        })
        .catch((_) => {});
    },
    handleCompanyInfoOpen(cid) {
      this.companyInfoDrawer = true;
      setTimeout(() => {
        this.companyInfoId = cid;
      });
    },
    handleCompanyInfoBeforeClose(done) {
      this.companyInfoId = null;
      done();
    },
  },
  mounted() {
    this.getPageData();
  },
};
</script>

<style scoped>

.table-container-footer {
  margin-top: 20px;
}
.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}

.staff_info >>> .success-row {
  background: #f0f9eb;
}

.staff_info >>> .el-table__header th {
  color: #333;
  background-color: #ecf4ff;
}

.el-drawer__wrapper >>> .el-timeline-item__wrapper {
  top: 0;
}

.el-timeline-item__node--large {
  width: 0.4rem;
  height: 0.4rem;
}

.public {
  display: flex;
  width: 100%;
  box-sizing: border-box;
}

.el-date-editor {
  width: 100% !important;
}

.mt-10 {
  margin-top: 0.2rem;
}

.mb-10 {
  margin-bottom: 0.2rem;
}

.el-select, .el-cascader {
  width: 100%;
}

.image {
  width: 2rem;
  height: 2rem;
  border-radius: 3px;
}

.staff_info {
  padding: 1.42rem 0.4rem 0.4rem 0.4rem;
  max-height: 100vh;
}
.el-pagination {
  padding-top: 10px;
}
.drawer-content {
  padding: 0 0.4rem 0 0.4rem;
}

.hide-style {
  display: inherit;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-r {
  text-align: right;
}
.m-label {
  line-height: 0.5rem;
}
.header-style {
  height: 100px !important;
  padding: 0px !important;
}
.el-position {
  font-family: Arial, 'Microsoft Yahei', 'Helvetica Neue', Helvetica, sans-serif;
}
.main-style {
  padding: 0px !important;
}
.count_style {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.icon-qingtonghuiyuan {
  color: #E9935D;
}
.icon-baiyinhuiyuan {
  color: #E6E8FA;
}
.icon-huangjinhuiyuan {
  color: #FFD32F;
}
.icon-qingtong {
  color: #40BBEC;
}
.icon-zuanshi {
  color: #83A4FF;
}
.icon-wangzhe {
  color: #A8A8A8;
}
.el-icon-chat-dot-square {
  color: #88D023;
}
.footer-style {
  text-align: right;
}

.el-drawer__wrapper >>> .el-drawer__header span {
  color: #4c87fc;
  font-size: 0.36rem;
  font-weight: 400;
}

.el-drawer__wrapper >>> .el-timeline-item__wrapper {
  top: 0;
}

.el-collapse >>> .el-collapse-item__header {
  color: #4C87FC;
  font-weight: bold;
}

.el-collapse >>> .el-collapse-item__arrow {
  color: #4C87FC;
}
.my_style >>> .el-form-item__label {
  width: 150px!important;
}
.my_style >>> .el-form-item__content {
  margin-left: 150px!important;
}
.my_style >>> .el-form-item--mini {
  width: 50%!important;
  float: left!important;
}
.my_style >>> .dplx-item-title {
  border-left: 6px solid #4c87fc;
  box-sizing: border-box;
  margin: 4px 0;
  padding-left: 10px;
  position: relative;
  margin-bottom: 15px;
}
.my_style >>> .el-tabs__nav{
  height: 770px
}
</style>



// WEBPACK FOOTER //
// src/pages/staff_info/StaffInfo.vue